import React, { Component } from 'react';
import './css/tinkerGround.css';
//import { TweenMax, Sine, Expo } from "gsap/TweenMax";

import * as THREE from 'three';
import Stats from 'stats-js';
import noise from './perlin';
import Dust from './dust/Dust.js';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
//import { MaskPass } from 'three/examples/jsm/postprocessing/MaskPass.js';
import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js';
import { LightProbeGenerator } from 'three/examples/jsm/lights/LightProbeGenerator.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { Lensflare, LensflareElement } from 'three/examples/jsm/objects/Lensflare.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

import { isMobile } from "react-device-detect";
import { TweenMax, TimelineMax, Sine, Back, Expo, Power4, Circ, Bounce } from "gsap";

import Cookies from 'js-cookie';

class TinkerGrounds extends Component {
  
  constructor(props) {

    super(props);

    this.state = {
      ratioDivisor: this.props.ratioDivisor,
      weakDeviceRatioDivisor: this.props.weakDeviceRatioDivisor,
      textureArray: this.props.textures,
    }

  }



  /* ---------------------------------------------------------------------------------------------------------------------- */
  /* -- load: model(s) ---------------------------------------------------------------------------------------------------- */
  /* ---------------------------------------------------------------------------------------------------------------------- */

  loadModel() {

    let _self  = this;


    const gltfLoader = new GLTFLoader();
    const url1 = './models/bambi.gltf';
    const url2 = './models/horse.gltf';


    
    gltfLoader.load(url1, (gltf) => {

        _self.model_bambi = gltf.scene;


        const gltfLoader1 = new GLTFLoader();

        gltfLoader1.load(url2, (gltf) => {

            _self.model_deer = gltf.scene;


            //_self.loadCount = 9;

            //window.setLoader( Math.round( _self.loadCount / ( _self.state.textureArray.length + 1 ) * 100 / 1.0 ) );

            _self.loadTextures();

        }, function(xhr) {

              if ( xhr.lengthComputable ) {

                   let getPercentage = Math.round( xhr.loaded / xhr.total * 100 );

                   if( getPercentage > 40 ) {

                       getPercentage -= 40;
                       window.setLoader( getPercentage );

                   }

             } 

        } );

        //_self.loadCount = 9;

        //window.setLoader( Math.round( _self.loadCount / ( _self.state.textureArray.length + 1 ) * 100 / 1.0 ) );

        //_self.loadTextures();

    }, function(xhr) {

          if ( xhr.lengthComputable ) {

               let getPercentage = Math.round( xhr.loaded / xhr.total * 100 );

               if( getPercentage > 20 ) {

                   getPercentage -= 20;
                   window.setLoader( getPercentage );

               }

         } 

    } );

  }


  /* ---------------------------------------------------------------------------------------------------------------------- */
  /* -- load: all textures ------------------------------------------------------------------------------------------------ */
  /* ---------------------------------------------------------------------------------------------------------------------- */

  loadTextures() {

    let _self = this;

    if( this.loadCount < this.state.textureArray.length ) {

        var loadTexture = new THREE.TextureLoader(); 
        loadTexture.load( this.state.textureArray[this.loadCount][0], function ( texture ) {

            texture.encoding = THREE.sRGBEncoding;    
            _self.state.textureArray[_self.loadCount][1] = texture;
            _self.loadCount += 1;

            window.setLoader( Math.round(_self.loadCount / _self.state.textureArray.length * 100 / 1.0 ) );
            _self.loadTextures();

        });   

    } else {

      var myVar     = setInterval( myTimer, 30 );
      var opacity   = 2.0;
      
      this.initScene();

      function myTimer() {
          
          if( _self.isRunning ) {
              
              opacity  -= 0.2;

              if( opacity <= 0 ) {

                  clearInterval(myVar);
                  document.getElementById( "loading" ).style.display = "none";
                  
              } else {

                  document.getElementById( "loading" ).style.opacity = opacity;


              }

          }

      }

    }

  }
  

  /* ---------------------------------------------------------------------------------------------------------------------- */
  /* -- init: 3d scene(s) ------------------------------------------------------------------------------------------------- */
  /* ---------------------------------------------------------------------------------------------------------------------- */

  initScene() {

    let _self = this;

    ////////////////////////////////////////////////////////////////////
    // get:                    /////////////////////////////////////////
    // dom element´s container /////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////

    this.container = this.refs.container;

    this.width     = this.container.offsetWidth;
    this.height    = this.container.offsetHeight;

    
    ////////////////////////////////////////////////////////////////////
    // setup:                    ///////////////////////////////////////
    // threejs clock & timers    ///////////////////////////////////////
    ////////////////////////////////////////////////////////////////////

    this.time      = 0;
    this.lastFrame = Date.now();
    this.thisFrame = null;
    this.material  = null;


    ////////////////////////////////////////////////////////////////////
    // setup:           ////////////////////////////////////////////////
    // renderer         ////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////

    this.renderer   = new THREE.WebGLRenderer({
      antialias:false,
      preserveDrawingBuffer: false,
      alpha:false,
      logarithmicDepthBuffer:false,
      powerPreference: 'high-performance'      
    });

    if( window.devicePixelRatio > 1 ) {

        this.renderer.setPixelRatio( window.devicePixelRatio * this.state.ratioDivisor );

    } else {

        this.renderer.setPixelRatio( window.devicePixelRatio * this.state.weakDeviceRatioDivisor );

    }

    if( isMobile ) {

        this.renderer.setPixelRatio( window.devicePixelRatio * 0.7 );

    }

    this.renderer.setSize( this.width, this.height );
    this.renderer.gammaInput = true;
    this.renderer.gammaOutput = true;
    this.renderer.gammaFactor = 2.2;
    this.renderer.physicallyCorrectLights = true;
    this.renderer.shadowMap.enabled = true;
    this.renderer.powerPreference = "high-performance";
    this.renderer.shadowMap.type = THREE.VSMShadowMap;
    this.renderer.outputEncoding = THREE.sRGBEncoding;



    ////////////////////////////////////////////////////////////////////
    // setup:           ////////////////////////////////////////////////
    // scene(s)         ////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////

    var fognear = 5, fogdist = 26;
    var fogColor = new THREE.Color( 0xD8DCE0 );
    this.scene = new THREE.Scene();
    this.scene.fog = new THREE.Fog( fogColor, fognear, fogdist );
    this.scene.position.y -= 1.3;
    //this.scene.background = this.state.textureArray[1][1];
    //this.scene.background.encoding = THREE.sRGBEncoding;    


    ////////////////////////////////////////////////////////////////////
    // setup:           ////////////////////////////////////////////////
    // camera(s)        ////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////

    this.camera     = new THREE.PerspectiveCamera( 70, this.width/this.height, 1.0, 100 );
    this.camera.position.z = -10;
    this.camera.updateProjectionMatrix();



    ////////////////////////////////////////////////////////////////////
    // setup:           ////////////////////////////////////////////////
    // postprocessing   ////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////

    this.composer = new EffectComposer( this.renderer );
    this.composer.addPass( new RenderPass( this.scene, this.camera ) );
    

    // depth pass
    this.depthMaterial = new THREE.MeshDepthMaterial();
    this.depthMaterial.depthPacking = THREE.RGBADepthPacking;
    this.depthMaterial.blending = THREE.NoBlending;
    

    this.depthRenderTarget = new THREE.WebGLRenderTarget( this.width, this.height );
    this.depthRenderTarget.texture.format = THREE.RGBFormat;
    this.depthRenderTarget.texture.minFilter = THREE.NearestFilter;
    this.depthRenderTarget.texture.magFilter = THREE.NearestFilter;
    this.depthRenderTarget.texture.generateMipmaps = false;
    this.depthRenderTarget.stencilBuffer = false;
    this.depthRenderTarget.depthBuffer = true;
    this.depthRenderTarget.depthTexture = new THREE.DepthTexture();
    this.depthRenderTarget.depthTexture.type = THREE.UnsignedShortType;


    this.singlePassBokehShader = {
        vertexShader: [

            "varying vec2 vUv;",

            "void main() {",
                "vUv = uv;",
                "gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);",
            "}"

        ].join( "\n" ),
        fragmentShader: [

            "#include <packing>",
            "#define DISPLAY_GAMMA 1.8",

            "varying vec2 vUv;",
            "uniform sampler2D tDiffuse;",
            "uniform sampler2D tDepth;",
            "uniform float cameraNear;",
            "uniform float cameraFar;",
            "uniform vec2 resolution;",

            "const float GOLDEN_ANGLE = 2.39996323;",
            "const float MAX_BLUR_SIZE = 20.0;",
            "const float RAD_SCALE = 0.5;", // Smaller = nicer blur, larger = faster

            "float getBlurSize(float depth, float focusPoint, float focusScale)",
            "{",
                "float coc = clamp((1.0 / focusPoint - 1.0 / depth)*focusScale, -1.0, 1.0);",
                "return abs(coc) * MAX_BLUR_SIZE;",
            "}",


            "float readDepth( sampler2D depthSampler, vec2 coord ) {",
                "float fragCoordZ = texture2D( depthSampler, coord ).x;",
                "float viewZ = perspectiveDepthToViewZ( fragCoordZ, cameraNear, cameraFar );",
                "return viewZToOrthographicDepth( viewZ, cameraNear, cameraFar );",
            "}",


            "vec3 depthOfField(vec2 texCoord, float focusPoint, float focusScale)",
            "{",
                "vec4 Input = texture2D( tDiffuse, texCoord).rgba;",
                "float centerDepth = Input.a * 10.2;",
                "float centerSize = getBlurSize(centerDepth, focusPoint, focusScale);",
                "vec3 color = Input.rgb;",
                "float tot = 1.0;",



                "float radius = RAD_SCALE;",
                "vec2 texelSize = 1.0 / resolution.xy;",

                "for ( float ang = 0.0; ang<130.0; ang+=GOLDEN_ANGLE ) {",

                       "vec2 tc = texCoord + vec2(cos(ang), sin(ang)) * texelSize * radius;",
                        
                       "vec4 sampleInput = texture2D(tDiffuse, tc).rgba;",
                       "vec3 sampleColor = sampleInput.rgb;",
                        "float sampleDepth = sampleInput.a * 10.2;",
                       "float sampleSize = getBlurSize(sampleDepth, focusPoint, focusScale);",

                       "if (sampleDepth > centerDepth) sampleSize = clamp(sampleSize, 0.0, centerSize*2.0);",

                       "float m = smoothstep(radius-0.5, radius+0.5, sampleSize);",
                       "color += mix(color/tot, sampleColor, m);",
                       "tot += 1.0;",
                       "radius += RAD_SCALE/radius;",

                       "if( radius >= MAX_BLUR_SIZE ) break;",

                "}",

                "return color /= tot;",

            "}",


            "void main() {", 

                "vec4 color1 = texture2D(tDiffuse, vUv).rgba;",
                
                "float focusPoint = 50.0;",
                "float focusScale = 4.65;",

                "color1.rgb = depthOfField(vUv, 8.0 * 1.7, focusScale);",
                
                //tone mapping
                "color1.rgb = vec3(1.7, 1.8, 1.9) * color1.rgb / (1.0 + color1.rgb);",

                //"float depth = readDepth( tDepth, vUv );",
                //"gl_FragColor.rgb = 1.0 - vec3( depth );",
                //"gl_FragColor.a = 1.0;",
                "gl_FragColor = vec4(pow(color1.rgb, vec3(1.0 / DISPLAY_GAMMA)), 1.0);",
            "}"

        ].join( "\n" ),  
        uniforms: {
            cameraNear: { value: 0 },
            cameraFar: { value: 0 },
            tDiffuse: { value: null },
            tDepth: { value: null },
            resolution: { value: new THREE.Vector2() }
        }
    };


    this.bokehPass = new ShaderPass( this.singlePassBokehShader );
    this.bokehPass.uniforms.cameraNear.value = this.camera.near;
    this.bokehPass.uniforms.cameraFar.value = this.camera.far;
    this.bokehPass.uniforms.tDepth.value = this.depthRenderTarget.depthTexture;
    this.bokehPass.uniforms.tDiffuse.value = this.depthRenderTarget.texture;
    this.bokehPass.uniforms[ 'resolution' ].value.x = this.width;
    this.bokehPass.uniforms[ 'resolution' ].value.y = this.height;



    this.chromaticAberrationShader = {
        vertexShader: [

            "varying vec2 vUv;",

            "void main() {",
                "vUv = uv;",
                "gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);",
            "}"

        ].join( "\n" ),
        fragmentShader: [

            "const float SAMPLES = 30.;",
            "varying vec2 vUv;",
            "uniform sampler2D tDiffuse;",

            "void main() {", 

                "vec2 uv = vUv;",
                //so we need some coefficients
                "float weight = 0.0092;", //weighting factor to get a weighted of each sample orback to 0.08
                        
                "float decay = 0.965;", //used to decrease the weighting fact so each step adds less to the sum,
                //to model scattering and absortion
                "float density = 0.9;",//0.3 //used to scale the step size of the samples and step size(or totaal distance)
                //determines how far in each ray direction calulations and bluring is done for
                //higher density means longer streaks of light and also more blur
                "float exposure = 3.1;",  //or back to 1.1
                //we subtract 0.5 to shift it to -0.5 to +0.5 so 0.0, 0.0 is center of screen
                //so the blur goes out in all directions
                "vec2 tuv = uv-0.5;", //also we use a new vec2 because we still need uv for sampling and "jitter"
    
                "vec2 duv = tuv/SAMPLES*density;",
    
                "vec4 initColor = texture2D(tDiffuse, uv.xy)*0.25;",//portion of total color to start with.
                //color in this case comes from channel0 which is a buffer that returns the scene color
    
                //jitter is a way of reducing banding which is a type of artifact... which we don't want
                //shane's version uses time to change the jitter which seems like a good idea but I'm
                //going for simple right now so I'm going with Passions which is just muliplying duv and random
    
                //this is added as an offset to uv.  uv which will be used to sample each texture in the alg loop.
                //so we add a random percentage of duv to uv.
                //random is key because the issue is banding is you get these weird lines or waves
                //so to smooth them out you can offset each point by a random amount.
                "uv+=duv*fract(sin(dot(uv, vec2(12.9898, 78.233)))*43758.5453);",
    
                "for(float i=0.;i<SAMPLES;i++)",
                "{",
                    
                 
                    //for each step move along the ray towards the center(uv - stepsize for all steps
                    //where step is fraction of uv, will result in 0, 0 the middle
                    "uv-=duv;",
                    
                    //add weighted percentage of scene color
                    "initColor+=texture2D(tDiffuse, uv)*weight;",
                    
                    "weight*=decay;",//decay the weight.
                    
                "}",
    
                "initColor*=exposure;",
                "initColor*= (1. - dot(tuv, tuv)*.975);",
                "gl_FragColor = vec4(vec3(initColor),1.0);",
            "}"

        ].join( "\n" ),  
        uniforms: {
            tDiffuse: { value: null },
        }
    };


    this.chromaticAberrationPass = new ShaderPass( this.chromaticAberrationShader );
    this.chromaticAberrationPass.uniforms.tDiffuse.value = this.depthRenderTarget.texture;


    this.tiltShiftShader = {
        uniforms: {
            tDiffuse: { value: this.depthRenderTarget.texture },
            resolution: { value: new THREE.Vector2() }
        },
        vertexShader: [

          "varying vec2 vUv;",

          "void main() {",
              "vUv = uv;",
              "gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);",
          "}"

        ].join( "\n" ),

        fragmentShader: [

            "uniform sampler2D tDiffuse;",
            "uniform vec2 resolution;",
            "varying vec2 vUv;",

            "float normpdf(in float x, in float sigma)",
            "{",
                "return 0.39894*exp(-0.5*x*x/(sigma*sigma))/sigma;",
            "}",

            "void main() {",

                "vec4 sum = vec4(0);",
                // How much the shift is visible.
                "const float shiftPower = 1.9;",
                 
                "vec4 color = vec4(texture2D(tDiffuse, vUv).rgb, 1.0);",
                    
                //declare stuff
                "const int mSize = 10;",
                "const int kSize = (mSize-1)/2;",
                "float kernel[mSize];",
                "vec3 final_colour = vec3(0.0);",
                //create the 1-D kernel
                "float sigma = 3.0;",
                "float Z = 0.0;",

                "for (int j = 0; j <= kSize; ++j)",
                    "kernel[kSize+j] = kernel[kSize-j] = normpdf(float(j), sigma);",

                //get the normalization factor (as the gaussian has been clamped)
                "for (int j = 0; j < mSize; ++j)",
                    "Z += kernel[j];",
                
                //read out the texels
                "for (int i=-kSize; i <= kSize; ++i)",
                "{",
                    "for (int j=-kSize; j <= kSize; ++j)",
                        "final_colour += kernel[kSize+j]*kernel[kSize+i]*texture2D(tDiffuse, (gl_FragCoord.xy+vec2(float(i),float(j))) / resolution.xy).rgb;",
                "}",

                "float val = clamp(shiftPower * abs(resolution.y/2.0 - gl_FragCoord.y) / (resolution.y/2.0), 0.0, 1.0);",
                "vec4 preColour = vec4(final_colour/(Z*Z), 1.0) * val + color * (1.0 - val);",

                "vec4 sum1 = preColour;",
                "const vec3 W = vec3(0.2125, 0.7154, 0.0721);",
                "vec3 intensity = vec3(dot(sum1.rgb, W));",
                "float adjustment = 2.0;",

                "gl_FragColor = vec4( mix(intensity, sum1.rgb, adjustment), 1.0);",

          "}"

        ].join( "\n" ) 

    };
    this.tiltShiftPass = new ShaderPass( this.tiltShiftShader );
    var pixelRatio = this.renderer.getPixelRatio();
    this.tiltShiftPass.material.uniforms[ 'resolution' ].value.x = this.width * pixelRatio;
    this.tiltShiftPass.material.uniforms[ 'resolution' ].value.y = this.height * pixelRatio;
    this.tiltShiftPass.renderToScreen = true




    this.simpleSaturationShader = {

        uniforms: {
            tDiffuse: { value: this.depthRenderTarget.texture },
            adjust: { value: 0.0 },
        },

        vertexShader: [

          "varying vec2 vUv;",

          "void main() {",
              "vUv = uv;",
              "gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);",
          "}"

        ].join( "\n" ),

        fragmentShader: [

            "uniform sampler2D tDiffuse;",
            "uniform float adjust;",
            "varying vec2 vUv;",
          

            "void main() {",

                "vec4 sum = vec4(0.);",
                "vec2 uv = vUv;",
                "vec2 uv101 = vUv;",

                "sum += texture2D( tDiffuse, uv );",

                "uv = uv101 * (1. - uv101);",  
                "sum *= pow(uv.x*uv.y * 25., 0.09);",

                "vec4 sum1 = sum;",
                "const vec3 W = vec3(0.2125, 0.7154, 0.0721);",
                "vec3 intensity = vec3(dot(sum1.rgb, W));",
                "float adjustment = adjust;",

                "gl_FragColor = vec4( mix(intensity, sum1.rgb, adjustment), 1.0);",


          "}"

        ].join( "\n" ) 

    };
    this.simpleSaturationPass = new ShaderPass( this.simpleSaturationShader );
    this.simpleSaturationPass.uniforms.adjust.value = 2.4;

    this.simpleGrainShader = {

      uniforms: {
        tDiffuse: { value: null },
        time: { value: null },
        resolution: { type: 'v2', value: new THREE.Vector2(512.0, 512.0) },
      },

      vertexShader: [
        'varying vec2 vUv;',

        'void main() {',
        'vUv = uv;',
        'gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);',
        '}',
      ].join('\n'),

      fragmentShader: [
        'uniform sampler2D tDiffuse;',
        'uniform vec2 resolution;',
        'uniform float time;',
        'varying vec2 vUv;',

        'void main() {',

        'vec2 aspect = vec2(resolution.x/resolution.y, 1.0);',
        'vec2 screenCoords = (2.0*gl_FragCoord.xy/resolution.xy - 1.0)*aspect;',
        'vec4 color = texture2D( tDiffuse, vUv );',
        'vec2 random_seed_1 = vec2(12.9898,78.233);',
        'float random_seed_2 = 43758.5453;',
        'float c = fract(sin(dot(screenCoords.xy ,random_seed_1)) * random_seed_2+(time * 0.5));',

        'color.xyz = (color.xyz*0.95)+(color.xyz*0.03*vec3(c));',

        'gl_FragColor = color;',

        '}',
      ].join('\n'),
    };

    this.simpleGrainPass = new ShaderPass(this.simpleGrainShader);
    this.simpleGrainPass.uniforms.time.value = 0.0;

    this.fxaaPass = new ShaderPass( FXAAShader );
    this.fxaaPass.material.uniforms[ 'resolution' ].value.x = 1 / ( this.width * pixelRatio );
    this.fxaaPass.material.uniforms[ 'resolution' ].value.y = 1 / ( this.height * pixelRatio );
    this.fxaaPass.renderToScreen = true;



    //this.composer.addPass( this.bokehPass );
    //this.composer.addPass( this.chromaticAberrationPass );
    //this.composer.addPass( this.tiltShiftPass );
    this.composer.addPass( this.simpleSaturationPass );
    this.composer.addPass( this.simpleGrainPass );
   // this.composer.addPass( this.tiltShiftPass );
    this.composer.addPass( this.fxaaPass );



    ////////////////////////////////////////////////////////////////////
    // setup:           ////////////////////////////////////////////////
    // orbit-controls   ////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////

    this.camera.userData = {
        phi:1.527995022187163, 
        theta:2.204373083463552, 
        zoom:10,
        //minZoom:5,
        //maxZoom:11,
        //onStart:true,
        play:false
    };

    this.controls   = new OrbitControls( this.camera, this.renderer.domElement, { 
        phi:1.527995022187163, 
        theta:2.204373083463552, 
        zoom:10,
        minZoom:5,
        maxZoom:11,
        onStart:true 
    } );

    this.controls.autoRotate = false;   
    this.controls.update(); 



    ////////////////////////////////////////////////////////////////////
    // setup:                  /////////////////////////////////////////
    // dust                    /////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////

    this.dust = new Dust();
    this.dust.init( this.scene, this.camera, this.state.textureArray[17][1] );
    this.scene.add( this.camera );



    ////////////////////////////////////////////////////////////////////
    // setup:           ////////////////////////////////////////////////
    // geometry         ////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////




    ////////////////////////////////////////////////////////////////////
    // setup:           ////////////////////////////////////////////////
    // light(s)         ////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////

    this.ambient = new THREE.AmbientLight(0x4D4D4D, 9.0 );
    this.scene.add( this.ambient );

    this.lightContainer = new THREE.Object3D();

    var studioLightRight = new THREE.DirectionalLight( 0xFFFFFF, 0.5 );
    studioLightRight.name = 'Studio-LightRight';
    studioLightRight.position.set( -11, 9, 3.5 );
    studioLightRight.castShadow = true;        
    studioLightRight.shadow.bias = -0.0001;
    studioLightRight.shadow.mapSize.width = 1024*4;
    studioLightRight.shadow.mapSize.height = 1024*4;        

    this.lightContainer.add( studioLightRight );


    //var studioLightLeft = new THREE.DirectionalLight( 0xFFFFFF, 0.5 );
    //studioLightLeft.name = 'Studio-LightLeft';
    //studioLightLeft.position.set( -11, 9, -1.5 );
    //this.lightContainer.add( studioLightLeft );

    this.scene.add( this.lightContainer );
    this.scene.add( this.ambient );



    ////////////////////////////////////////////////////////////////////
    // add:         ////////////////////////////////////////////////////
    // LensFlare    ////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////
    
    var light = new THREE.PointLight( 0xffff00, 0.0, 20 );

    var lensflare = new Lensflare();

    //lensflare.addElement( new LensflareElement( this.state.textureArray[13][1], 512, 0 ) );
    lensflare.addElement( new LensflareElement( this.state.textureArray[14][1], 412, 0.05 ) );
    lensflare.addElement( new LensflareElement( this.state.textureArray[15][1], 312, 0.15 ) );
    lensflare.addElement( new LensflareElement( this.state.textureArray[16][1], 212, 0.25 ) );

    light.add( lensflare );

    light.position.y =  8;
    light.position.x =  -14;
    light.position.z = -8;

    this.scene.add( light );



    ////////////////////////////////////////////////////////////////////
    // add:         ////////////////////////////////////////////////////
    // LightProbe   ////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////

    this.lightProbe = new THREE.LightProbe();
    var self = this;

    var loader = new THREE.CubeTextureLoader();
    loader.setPath( './lightProbeEnv/' );
    loader.load(
 
        // urls of images used in the cube texture
        ['px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'],
     
        // what to do when loading is over
        function (cubeTexture) {

          cubeTexture.encoding = THREE.sRGBEncoding;
            
            self.lightProbe.copy( new LightProbeGenerator.fromCubeTexture( cubeTexture ) );
            self.lightProbe.intensity = 15;
            //self.scene.add( self.lightProbe );
     
        }
 
    );


    ////////////////////////////////////////////////////////////////////
    // add:         ////////////////////////////////////////////////////
    // Skybox   ////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////
    /*let materialArray = [];

  
    materialArray.push(new THREE.MeshBasicMaterial( { map: this.state.textureArray[9][1] } ) );
    materialArray.push(new THREE.MeshBasicMaterial( { map: this.state.textureArray[10][1] } ) );
    materialArray.push(new THREE.MeshBasicMaterial( { map: this.state.textureArray[11][1] } ) );
    materialArray.push(new THREE.MeshBasicMaterial( { map: this.state.textureArray[12][1] } ) );
    materialArray.push(new THREE.MeshBasicMaterial( { map: this.state.textureArray[13][1] } ) );
    materialArray.push(new THREE.MeshBasicMaterial( { map: this.state.textureArray[14][1] } ) );
       
    for (let i = 0; i < 6; i++)
      materialArray[i].side = THREE.BackSide;
       
    let skyboxGeo = new THREE.BoxGeometry( 70, 70, 70);
    let skybox = new THREE.Mesh( skyboxGeo, materialArray );
    skybox.position.y += 3;
    //this.scene.add( skybox );*/


    let geometry = new THREE.SphereBufferGeometry( 50, 20, 10 );
    // invert the geometry on the x-axis so that all of the faces point inward
    geometry.scale( - 1, 1, 1 );

    let material = new THREE.MeshBasicMaterial( { map: this.state.textureArray[8][1], fog: false, transparent: true, side:THREE.FrontSide } );

    this.equiMap = new THREE.Mesh( geometry, material );
    this.equiMap.position.y -= 3;

    this.scene.add( this.equiMap );


    if( isMobile ) this.areaWidth = 100;

    ////////////////////////////////////////////////////////////////////
    // add:             ////////////////////////////////////////////////
    // terrain ground   ////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////
    
    this.groundObj = new THREE.Group();
    this.ground = this.setupGround( this.groundObj );
    this.ground.scale.set(0.25,0.25,0.25);



    ////////////////////////////////////////////////////////////////////
    // add:                                              ///////////////
    // renderer´s domElement (canvas) to container (div) ///////////////
    ////////////////////////////////////////////////////////////////////

    this.container.appendChild( this.renderer.domElement );
    //this.container.appendChild( this.stats.dom );



    ////////////////////////////////////////////////////////////////////
    // add:                                              ///////////////
    // custom event.handling                             ///////////////
    ////////////////////////////////////////////////////////////////////

    const moveCamTo = ( pos, rotY, posX ) => {

        //let mesh:THREE.Mesh = (this.marker.children[0] as THREE.Mesh);
        //TweenMax.to( mesh.material, 0.8, { opacity:0.0, ease:Cubic.easeOut } ); 

        TweenMax.to(_self.groundObj.rotation, 2.0, {
            y: rotY,
            ease:Sine.easeInOut,
        } );

        TweenMax.to(_self.groundObj.position, 2.0, {
            x: posX,
            ease:Sine.easeInOut,
        } );        

        TweenMax.to(_self.camera.position, 2.0, {
            x: pos.x,
            y: pos.y,
            z: pos.z,
            ease:Circ.easeInOut,
            onUpdate:function() {
                _self.updateCameraOrbit();
            },
            onComplete:function() {
                //self.updateCameraOrbit();
                _self.markerIsSet = false;
                //TweenMax.to( mesh.material, 0.8, { opacity:1.0, ease:Sine.easeOut } ); 
            }
        } ); 

    }


    document.addEventListener("navi01", (e) => {

        if( !_self.coockies ) return;
        if( _self.markerIsSet ) return;

        document.getElementById( "mobileResultWrapper" ).style.display = "none";
        this.groundObj.remove( this.moviePlane );
        this.groundObj.remove( this.model_bambi );
        this.groundObj.remove( this.model_deer );

        this.video.pause();
        this.video.currentTime = 0;
        this.moviePlane.material = _self.moviePlane.userData.shaded; 
        document.getElementById( "closeVideo" ).style.display = "none";

        TweenMax.to( this.simpleSaturationPass.uniforms.adjust, 0.25, { value:2.4 } );

        if( _self.topic === 3 ) {

            let ground = null;
            let ground1 = null;

            for( let i=_self.groundObj.children.length-1; i >= 0; i-- ) {

                 let getMesh = _self.groundObj.children[i];
                 
                 if( getMesh.name.indexOf( "ground", 0) === -1 ) {

                     if( getMesh.userData.y ) {

                         var initial = new THREE.Color(getMesh.material.color);
                         var value = new THREE.Color( 0xDDDDDD );
                          
                         TweenMax.to(initial, 1, {
                            r: value.r,
                            g: value.g,
                            b: value.b,
                            ease:Sine.easeOut,
                            delay:0.5,

                            onUpdate: function () {
                              getMesh.material.color = initial;
                            }

                         });

                         TweenMax.to( getMesh.position, 1.8 + Math.random() * 1.0, { y: getMesh.userData.y, ease:Sine.easeOut });
                         TweenMax.to( getMesh.rotation, 1.8 + Math.random() * 1.0, { x:getMesh.userData.rx, y: getMesh.userData.ry, ease:Sine.easeOut });
                     }

                 } else {

                      if( typeof ground === 'undefined' || ground === null ) {

                          ground = _self.groundObj.children[i];

                       } else {

                          ground1 = _self.groundObj.children[i];

                       }

                 }
            
            }
    
            TweenMax.to( ground.position, 1.0, { y:-1.95, ease:Expo.easeOut });
            TweenMax.to( ground.material, 0.5, { opacity:1.0, ease:Expo.easeOut });
            TweenMax.to( ground1.material, 0.5, { opacity:1.0, ease:Expo.easeOut });   
            TweenMax.to( _self.equiMap.material, 0.5, { opacity:1.0, ease:Expo.easeOut });
            TweenMax.to( _self.gridMat.uniforms.alphaValue, 0.5, { value:0.0, ease:Expo.easeOut, onComplete:function() {
                _self.scene.remove( _self.gridBase );
            }  });
        }

        document.getElementById( "navi01" ).className = "";
        document.getElementById( "navi01" ).className = "isItalic";
        document.getElementById( "navi01nr" ).className = "";
        document.getElementById( "navi01nr" ).className = "naviNumberActive";  

        document.getElementById( "navi02" ).className = "";
        document.getElementById( "navi02" ).className = "isNormal";
        document.getElementById( "navi02nr" ).className = "";  
        document.getElementById( "navi02nr" ).className = "isNormalNumber";  

        document.getElementById( "navi03" ).className = "";
        document.getElementById( "navi03" ).className = "isNormal";
        document.getElementById( "navi03nr" ).className = "";
        document.getElementById( "navi03nr" ).className = "isNormalNumber"; 

        document.getElementById( "navi04" ).className = "";
        document.getElementById( "navi04" ).className = "isNormal";
        document.getElementById( "navi04nr" ).className = "";
        document.getElementById( "navi04nr" ).className = "isNormalNumber";         

        document.getElementById( "navi05" ).className = "";
        document.getElementById( "navi05" ).className = "isNormal";
        document.getElementById( "navi05nr" ).className = "";
        document.getElementById( "navi05nr" ).className = "isNormalNumber"; 

        document.getElementById( "n03input" ).style.display = "";
        TweenMax.to( document.getElementById( "n03input" ), 0.5, { autoAlpha: 0 });
        document.getElementById( "allGreenResults" ).style.display = "none";
        document.getElementById( "greenQuestion" ).style.display = "none";
        document.getElementById( "greenThanks" ).style.display = "none";    
        document.getElementById( "greenResult" ).style.display = "none";  
        document.getElementById( "greenResultText" ).style.display = "none";

        TweenMax.to(".n01", 0.85, {left:"10px", opacity:"1.0", ease:Bounce.easeOut });
        TweenMax.to(".n02", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });
        TweenMax.to(".n03", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });
        TweenMax.to(".n04", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });
        TweenMax.to(".n05", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });

        let camMoveToPos = new THREE.Vector3( 8.051770306589177, 0.4278823748442191, -5.914888976407463 );

        _self.topic = 1;
        window["topic"] = 1;

        if( !_self.moviePlane.userData.isNormal ) {

            _self.moviePlane.material = _self.moviePlane.userData.material;
            _self.moviePlane.userData.isNormal = true;

        }

        if( !_self.markerIsSet ) moveCamTo( camMoveToPos, 0.0, 0.0 );

        _self.markerIsSet = true;

        TweenMax.to( document.getElementById('alltext'), 0.75, { autoAlpha:0, onComplete:function() {

            document.getElementById('txtnr01').style.display = "block";
            document.getElementById('txtnr02').style.display = "none";
            document.getElementById('txtnr03').style.display = "none";
            document.getElementById('txtnr04').style.display = "none";
            document.getElementById('txtnr05').style.display = "none";

            TweenMax.to( document.getElementById('alltext'), 0.75, { autoAlpha:1 } );

        } } );

    } );

    document.addEventListener("navi02", (e) => {

        if( !_self.coockies ) return;
        if( _self.markerIsSet ) return;

        document.getElementById( "mobileResultWrapper" ).style.display = "none";

        TweenMax.to( this.simpleSaturationPass.uniforms.adjust, 0.25, { value:2.4 } );

        if( _self.topic === 3 ) {

            let ground = null;
            let ground1 = null;

            for( let i=_self.groundObj.children.length-1; i >= 0; i-- ) {

                 let getMesh = _self.groundObj.children[i];
                 
                 if( getMesh.name.indexOf( "ground", 0) === -1 ) {

                     if( getMesh.userData.y ) {

                         var initial = new THREE.Color(getMesh.material.color);
                         var value = new THREE.Color( 0xDDDDDD );
                          
                         TweenMax.to(initial, 1, {
                            r: value.r,
                            g: value.g,
                            b: value.b,
                            ease:Sine.easeOut,
                            delay:0.5,

                            onUpdate: function () {
                              getMesh.material.color = initial;
                            }

                         });

                         TweenMax.to( getMesh.position, 1.8 + Math.random() * 1.0, { y: getMesh.userData.y, ease:Sine.easeOut });
                         TweenMax.to( getMesh.rotation, 1.8 + Math.random() * 1.0, { x:getMesh.userData.rx, y: getMesh.userData.ry, ease:Sine.easeOut });

                     }

                 } else {

                      if( typeof ground === 'undefined' || ground === null ) {

                          ground = _self.groundObj.children[i];

                       } else {

                          ground1 = _self.groundObj.children[i];

                       }

                 }
            
            }
    
            TweenMax.to( ground.position, 1.0, { y:-1.95, ease:Expo.easeOut });
            TweenMax.to( ground.material, 0.5, { opacity:1.0, ease:Expo.easeOut });
            TweenMax.to( ground1.material, 0.5, { opacity:1.0, ease:Expo.easeOut });   
            TweenMax.to( _self.equiMap.material, 0.5, { opacity:1.0, ease:Expo.easeOut });
            TweenMax.to( _self.gridMat.uniforms.alphaValue, 0.5, { value:0.0, ease:Expo.easeOut, onComplete:function() {
                _self.scene.remove( _self.gridBase );
            }  });
        }

        this.groundObj.add( this.moviePlane );
        this.groundObj.add( this.model_bambi );
        this.groundObj.add( this.model_deer );
        
        this.video.pause();
        this.video.currentTime = 0;
        this.moviePlane.material = _self.moviePlane.userData.shaded; 
        //this.videoObj.visible = false;
        document.getElementById( "closeVideo" ).style.display = "none";

        document.getElementById( "navi01" ).className = "";
        document.getElementById( "navi01" ).className = "isNormal";
        document.getElementById( "navi01nr" ).className = "";
        document.getElementById( "navi01nr" ).className = "isNormalNumber";             

        document.getElementById( "navi02" ).className = "";
        document.getElementById( "navi02" ).className = "isItalic";
        document.getElementById( "navi02nr" ).className = "";
        document.getElementById( "navi02nr" ).className = "naviNumberActive";  

        document.getElementById( "navi03" ).className = "";
        document.getElementById( "navi03" ).className = "isNormal";
        document.getElementById( "navi03nr" ).className = "";
        document.getElementById( "navi03nr" ).className = "isNormalNumber"; 

        document.getElementById( "navi04" ).className = "";
        document.getElementById( "navi04" ).className = "isNormal";
        document.getElementById( "navi04nr" ).className = "";
        document.getElementById( "navi04nr" ).className = "isNormalNumber";         

        document.getElementById( "navi05" ).className = "";
        document.getElementById( "navi05" ).className = "isNormal";
        document.getElementById( "navi05nr" ).className = "";
        document.getElementById( "navi05nr" ).className = "isNormalNumber"; 

        document.getElementById( "n03input" ).style.display = "";
        TweenMax.to( document.getElementById( "n03input" ), 0.5, { autoAlpha: 0 });
        document.getElementById( "allGreenResults" ).style.display = "none";
        document.getElementById( "greenQuestion" ).style.display = "none";
        document.getElementById( "greenThanks" ).style.display = "none";    
        document.getElementById( "greenResult" ).style.display = "none";  
        document.getElementById( "greenResultText" ).style.display = "none";

        TweenMax.to(".n01", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });
        TweenMax.to(".n02", 0.85, {left:"10px", opacity:"1.0", ease:Bounce.easeOut });
        TweenMax.to(".n03", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });
        TweenMax.to(".n04", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });
        TweenMax.to(".n05", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });

        let camMoveToPos = new THREE.Vector3( -22, 1, -13 );

        _self.moviePlane.userData.isNormal = false;
        _self.topic = 2;
        window["topic"] = 2;

        if( !_self.markerIsSet ) moveCamTo( camMoveToPos, -1.26, -10.0 );

        _self.markerIsSet = true;

        TweenMax.to( document.getElementById('alltext'), 0.75, { autoAlpha:0, onComplete:function() {

            document.getElementById('txtnr01').style.display = "none";
            document.getElementById('txtnr02').style.display = "block";
            document.getElementById('txtnr03').style.display = "none";
            document.getElementById('txtnr04').style.display = "none";
            document.getElementById('txtnr05').style.display = "none";

            TweenMax.to( document.getElementById('alltext'), 0.75, { autoAlpha:1 } );

        } } );

    } );


    document.addEventListener("navi03", (e) => {

        if( !_self.coockies ) return;
        if( _self.markerIsSet ) return;

        document.getElementById( "mobileResultWrapper" ).style.display = "none";
        this.groundObj.remove( this.moviePlane );
        this.groundObj.remove( this.model_bambi );
        this.groundObj.remove( this.model_deer );
            
        this.video.pause();
        this.video.currentTime = 0;
        this.moviePlane.material = _self.moviePlane.userData.shaded;   
        //this.videoObj.visible = false;
        document.getElementById( "closeVideo" ).style.display = "none";

        TweenMax.to( this.simpleSaturationPass.uniforms.adjust, 0.25, { value:2.4 } );

        document.getElementById( "navi01" ).className = "";
        document.getElementById( "navi01" ).className = "isNormal";
        document.getElementById( "navi01nr" ).className = "";
        document.getElementById( "navi01nr" ).className = "isNormalNumber";  

        document.getElementById( "navi02" ).className = "";
        document.getElementById( "navi02" ).className = "isNormal";
        document.getElementById( "navi02nr" ).className = "";
        document.getElementById( "navi02nr" ).className = "isNormalNumber";             

        document.getElementById( "navi03" ).className = "";
        document.getElementById( "navi03" ).className = "isItalic";
        document.getElementById( "navi03nr" ).className = "";
        document.getElementById( "navi03nr" ).className = "naviNumberActive";  

        document.getElementById( "navi04" ).className = "";
        document.getElementById( "navi04" ).className = "isNormal";
        document.getElementById( "navi04nr" ).className = "";
        document.getElementById( "navi04nr" ).className = "isNormalNumber";

        document.getElementById( "navi05" ).className = "";
        document.getElementById( "navi05" ).className = "isNormal";
        document.getElementById( "navi05nr" ).className = "";
        document.getElementById( "navi05nr" ).className = "isNormalNumber";             

        TweenMax.to(".n01", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });
        TweenMax.to(".n02", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });
        TweenMax.to(".n03", 0.85, {left:"10px", opacity:"1.0", ease:Bounce.easeOut });
        TweenMax.to(".n04", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });
        TweenMax.to(".n05", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });

        let camMoveToPos = new THREE.Vector3( -10, 2, 30 );
        camMoveToPos.y = _self.camera.position.y;

        _self.topic = 3;
        window["topic"] = 3;

        if( !_self.moviePlane.userData.isNormal ) {

            _self.moviePlane.material = _self.moviePlane.userData.material;
            _self.moviePlane.userData.isNormal = true;

        }

        if( !_self.markerIsSet ) moveCamTo( camMoveToPos, 0.55, -5.0 );

        _self.markerIsSet = true;

        TweenMax.to( document.getElementById('alltext'), 0.75, { autoAlpha:0, onComplete:function() {

            document.getElementById('txtnr01').style.display = "none";
            document.getElementById('txtnr02').style.display = "none";
            document.getElementById('txtnr03').style.display = "block";
            document.getElementById('txtnr04').style.display = "none";
            document.getElementById('txtnr05').style.display = "none";

            TweenMax.to( document.getElementById('alltext'), 0.75, { autoAlpha:1 } );

        } } );

        TweenMax.to( document.getElementById( "n03input" ), 1.0, { autoAlpha: 1, delay:2.0, onComplete:function() {

 
        } } );


    } );     


    document.getElementById( "mylocation" ).addEventListener ("keyup", (e) => {
        
        if ( e.key === 'Enter' || e.keyCode === 13 ) {
            
            let getFirst = document.getElementById('mylocation').value.split(",")[0];
            let getScnd = document.getElementById('mylocation').value.split(",")[1];

            if( getFirst.length < 2 ) return;

            fetch( "https://nominatim.openstreetmap.org/search?q=" + getFirst + "," + getScnd + "&format=json&polygon=1&addressdetails=1" )
            .then(res => res.json())
            .then((data) => {

                  if( data.length === 0 ) return;

                  document.getElementById( "loaders" ).style.display = "";
                  document.getElementById( "greenPercentage" ).style.display = "";
                  document.getElementById( "greenLoaderRect" ).style.display = "";
                  
                  TweenMax.to( document.getElementById( "n03input" ), 0.5, { autoAlpha: 0 });

                  TweenMax.to( document.getElementById('alltext'), 0.75, { autoAlpha:0 } );

                  let loadedCanvas = false;

                  var imageObj = new Image();

                  Image.prototype.load = function(url){
                        var thisImg = this;
                        var xmlHTTP = new XMLHttpRequest();
                        xmlHTTP.open('GET', url,true);
                        xmlHTTP.responseType = 'arraybuffer';
                        xmlHTTP.onload = function(e) {
                            var blob = new Blob([this.response]);
                            TweenMax.to( _self.simpleSaturationPass.uniforms.adjust, 1.0, { value:1.0 } );
                            imageObj.src = window.URL.createObjectURL(blob);
                        };
                        xmlHTTP.onprogress = function(e) {
                            //thisImg.completedPercentage = parseInt((e.loaded / e.total) * 100);
                            document.getElementById( "greenPercentage" ).innerHTML = parseInt((e.loaded / e.total) * 100) + "%";
                        };
                        xmlHTTP.onloadstart = function() {
                            thisImg.completedPercentage = 0;

                        };
                        xmlHTTP.send();
                  };

                  Image.prototype.completedPercentage = 0;

                  var imageObj = new Image();
                  imageObj.crossOrigin = "Anonymous";

                  imageObj.onload = function() {

                        _self.gridMat.uniforms.alphaValue.value = 0.0;
                        _self.scene.add( _self.gridBase );

                        var canvas = document.getElementById('myCanvas');
                        var context = canvas.getContext('2d');
                        var imageX = 0;
                        var imageY = 0;
                        var imageWidth = 512;
                        var imageHeight = 512;

                        context.drawImage(imageObj, imageX, imageY);

                        var imageData = context.getImageData(imageX, imageY, imageWidth, imageHeight);


                        var newCan = document.createElement('canvas');
                        newCan.width = 512;
                        newCan.height = 490;

                        var newCtx = newCan.getContext('2d');
                        newCtx.putImageData(imageData, 0, 0);

                        var imageData1 = newCtx.getImageData(0, 0, 512, 490);


                        // Get the length of image data object
                        let length = imageData1.data.length;

                        let rgb = { r: 0, g: 0, b: 0 };
                        let count = 0;
                        
                        for (var i = 0; i < length; i += 4) {
                            
                            // Sum all values of red colour
                            rgb.r += imageData1.data[i];
             
                            // Sum all values of green colour
                            rgb.g += imageData1.data[i + 1];
             
                            // Sum all values of blue colour
                            rgb.b += imageData1.data[i + 2];
             
                            // Increment the total number of
                            // values of rgb colours
                            count++;

                        }

                        // Find the average of red
                        rgb.r = Math.floor(rgb.r / count);
             
                        // Find the average of green
                        rgb.g = Math.floor(rgb.g / count);
             
                        // Find the average of blue
                        rgb.b = Math.floor(rgb.b / count);

                        //console.log( "red: " +  rgb.r );
                        //console.log( "green: " +  rgb.g );
                        //console.log( "blue: " +  rgb.b );

                        //newCtx.globalCompositeOperation = "overlay";  // AKA add / linear-dodge
                        //newCtx.fillStyle = /*"#DAE1E6"*/";
                        //newCtx.fillRect(0, 0, 512, 490);

                        let ground = null;
                        let ground1 = null;

                        for( let i=_self.groundObj.children.length-1; i >= 0; i-- ) {

                             let getMesh = _self.groundObj.children[i];
                             
                             if( getMesh.name.indexOf( "ground", 0) === -1 && getMesh.name.indexOf( "horses", 0 ) === -1 ) {

                                  var initial = new THREE.Color(getMesh.material.color);
                                  var value = new THREE.Color("rgb(" + rgb.r + "," + rgb.g + "," +  rgb.b + ")");
                                  
                                  TweenMax.to(initial, 1, {
                                    r: value.r,
                                    g: value.g,
                                    b: value.b,
                                    ease:Sine.easeOut,
                                    delay:0.5,

                                    onUpdate: function () {
                                      getMesh.material.color = initial;
                                    }

                                  });

                                 TweenMax.to( getMesh.position, 4.8 + Math.random() * 1.0, { y: Math.random() * 50, ease:Sine.easeOut });
                                 TweenMax.to( getMesh.rotation, 4.8 + Math.random() * 1.0, { x: -1.5 + Math.random() * 3, ease:Bounce.easeOut });

                             } else {

                                  if( typeof ground === 'undefined' || ground === null ) {

                                      ground = _self.groundObj.children[i];

                                   } else {

                                      ground1 = _self.groundObj.children[i];

                                   }

                             }
                        
                        }

                        let setGreen = ( getData ) => {

                            let writeData = true;

                            for( var i in getData.localGreens ) {

                                 if( window["lon"] === getData.localGreens[i].lon && window["lat"] === getData.localGreens[i].lat ) {

                                      writeData = false;

                                 }

                            }

                            let timerid = setTimeout(() => {
                                
                                document.getElementById( "loaders" ).style.display = "none";
                                document.getElementById( "greenPercentage" ).style.display = "none";
                                document.getElementById( "greenLoaderRect" ).style.display = "none";

                                let camMoveToPos = new THREE.Vector3( _self.camera.position.x + 15, 16, _self.camera.position.z - 15 );
                                moveCamTo( camMoveToPos, 0.55, -5.0 );

                                TweenMax.to( ground.position, 5.0, { y:-10.0, ease:Sine.easeOut, delay:1.5 });
                                TweenMax.to( ground.material, 1.0, { opacity:0.0, ease:Expo.easeOut, delay:0.5 });
                                TweenMax.to( ground1.material, 2.0, { opacity:0.0, ease:Expo.easeOut, delay:0.5 });   

                                TweenMax.to( _self.equiMap.material, 1.0, { opacity:0.0, ease:Sine.easeOut,  });
                                
                                const texture = new THREE.CanvasTexture(newCtx.canvas);
                                //let texture = new THREE.Texture( this );
                                texture.needsUpdate = true;
                                _self.scene.background = texture;

                                _self.gridBase.position.x = _self.camera.position.x;
                                _self.gridBase.position.y = 16;
                                _self.gridBase.position.z = _self.camera.position.z;
                                _self.gridBase.children[0].rotation.y = -1.2;
                                _self.gridBase.children[0].rotation.z =  -0.1;
                                _self.gridBase.children[0].visible = true;

                                _self.gridMat.uniforms.rgbTarget.value = new THREE.Color("rgb(" + rgb.r + "," + rgb.g + "," +  rgb.b + ")");

                                //TweenMax.to( _self.gridMat.uniforms.alphaValue, 4.0, { value:0.9, ease:Sine.easeOut, delay:1.5  });
                                document.getElementById( "greenResult" ).style.background = "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1.0 )";
                                document.getElementById( "greenResult" ).style.display = "";
                                document.getElementById( "greenResult" ).onclick = () => {

                                    copyToClipboard( "R:" + rgb.r + ",G: " + rgb.g + ",B: " + rgb.b );
                                }

                                if( _self.devMobile ) {

                                    document.getElementById( "mobileResultWrapper" ).style.display = "block";

                                }

                                //document.getElementById( "greenTitle" ).innerHTML = getFirst.replace(/[0-9]/g, '') + ",<br>" + getScnd.replace(/[0-9]/g, '');
                                document.getElementById( "greenResultText" ).style.display = "";
                                //document.getElementById( "yesButton" ).style.background = "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1.0 )";

                                TweenMax.to( document.getElementById( "n03input" ), 0.5, { autoAlpha: 0 });

                                document.getElementById( "greenQuestion" ).style.display = "";     
                                TweenMax.to( document.getElementById( "greenQuestion" ), 0.1, { autoAlpha: 1 });                            
                                TweenMax.to( document.getElementById( "greenResult" ), 1.0, { autoAlpha: 1, delay:1.5 });
                                TweenMax.to( document.getElementById( "greenResultText" ), 1.0, { autoAlpha: 1, delay:1.5 });
                                
                                if( writeData ) {

                                    getData.localGreens.push( 
                                        {
                                            lat:window["lat"],
                                            lon:window["lon"],
                                            address: getFirst.replace(/[0-9]/g, '') + "," + getScnd.replace(/[0-9]/g, ''),
                                            rgb: rgb
                                        }
                                    );
                                    
                                }
                                
                                let storeObj = {

                                    localGreens:getData.localGreens

                                }

                                window["sessionGreens"] = getData.localGreens;

                                //window["loadData"]();*/
                                window["storeData"]( storeObj );
                                //window["loadData"]();




                            }, 1500);  

                        }

                        window["loadData"]( setGreen );


                };

                if( data[0] ) {

                    if( data[0].lon ) {

                        window["lon"] = data[0].lon;
                        window["lat"] = data[0].lat;

                        imageObj.load('https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static/' + data[0].lon + ',' + data[0].lat + ',18.0,0,20/512x512?access_token=pk.eyJ1IjoicHdkdmVyZ2Vzc2VyIiwiYSI6ImNsNHliZDYzcjA0MmQzYnF2bDEyYTFjZTQifQ.K71flJ4gl4Gwj8UtJ4h1kA');
                        //imageObj.src = 'https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static/' + data[0].lon + ',' + data[0].lat + ',18.0,0,20/512x512?access_token=pk.eyJ1IjoicHdkdmVyZ2Vzc2VyIiwiYSI6ImNsNHliZDYzcjA0MmQzYnF2bDEyYTFjZTQifQ.K71flJ4gl4Gwj8UtJ4h1kA';

                    }
                }

            /*
var imageElement = document.createElement('img');
imageElement.onload = function(e) {
    texture = new THREE.Texture( this );
    texture.needsUpdate = true;
    init();
    animate();
};*/


            });   
            
        }

    });

    document.addEventListener("feedbackYes", (e) => {

        TweenMax.to( document.getElementById( "greenQuestion" ), 0.5, { autoAlpha: 0, ease:Expo.easeOut, onComplete:function() {
            
            document.getElementById( "greenQuestion" ).style.display = "none";
            document.getElementById( "greenThanks" ).style.display = "";
            TweenMax.to( document.getElementById( "greenThanks" ), 0.5, { autoAlpha: 1, ease:Sine.easeOut } );

        } } );

    } ); 


    document.addEventListener("feedbackNo", (e) => {

        TweenMax.to( document.getElementById( "greenQuestion" ), 0.5, { autoAlpha: 0, ease:Expo.easeOut, onComplete:function() {
            
            document.getElementById( "greenQuestion" ).style.display = "none";
            document.getElementById( "greenThanks" ).style.display = "";
            TweenMax.to( document.getElementById( "greenThanks" ), 0.5, { autoAlpha: 1, ease:Sine.easeOut } );

        } } );

    } );

    let copyToClipboard = ( rgbValue ) => {

          navigator.clipboard.writeText( rgbValue ).then(() => {
            
          });

    }

    document.addEventListener("initAllGreens", (e) => {

        let setGreen = ( getData ) => {

            TweenMax.to( document.getElementById('alltext'), 0.75, { autoAlpha:0 } );
            document.getElementById( "allGreenWrapper" ).innerHTML = "";

            window["sessionGreens"] = getData.localGreens;

            let showAllGreens = new CustomEvent("showAllGreens", { detail: "" });
            document.dispatchEvent( showAllGreens );   

            setTimeout( function() {

                document.getElementById( "resultsPos" ).style.display = "";

            }, 500 );
            
        }   

        window["loadData"]( setGreen );

    });

    document.addEventListener("showAllGreens", (e) => {

        TweenMax.to( document.getElementById( "greenResultText" ), 0.5, { autoAlpha: 0, ease:Expo.easeOut, onComplete:function() {

            document.getElementById( "greenQuestion" ).style.display = "none";
            document.getElementById( "greenThanks" ).style.display = "none";
            document.getElementById( "n03input" ).style.display = "none";

        } } );

        TweenMax.to( document.getElementById( "greenResult" ), 0.5, { autoAlpha: 0, ease:Expo.easeOut, onComplete:function() {
            
  
            document.getElementById( "allGreenWrapper" ).innerHTML = "";
            
            document.getElementById( "allGreenResults" ).style.display = "";
            document.getElementById( "allGreenResults" ).style.height = "";    

            if( _self.devMobile ) {

                document.getElementById( "allGreenResults" ).style.width = "90vw";
                document.getElementById( "allGreenWrapper" ).innerHTML = "<br><br><br><br><br><br>";

                var rect = document.getElementById( "allGreenWrapper" ).getBoundingClientRect();

                document.getElementById( "closeGreens" ).style.left = rect.width - 60 + "px";
                document.getElementById( "closeGreens" ).style.top = 40 + "px";  

            }

            for( let i=0; i < window["sessionGreens"].length; i++ ) {

                 if( _self.devMobile ) {

                    document.getElementById( "allGreenWrapper" ).innerHTML += "<span onclick='" + copyToClipboard( "R:" + window["sessionGreens"][i].rgb.r + ", G:"  + window["sessionGreens"][i].rgb.g + ", B:" + window["sessionGreens"][i].rgb.b ) + "' class='roundCorners roundCornersTextOverlays' style='background:rgb(" + window["sessionGreens"][i].rgb.r + "," +  window["sessionGreens"][i].rgb.g +  "," + window["sessionGreens"][i].rgb.b + ")'><div class='showOnHoverMobile'>" + window["sessionGreens"][i].address + "<br>Lat: " +  window["sessionGreens"][i].lat + "<br>Lon: " + window["sessionGreens"][i].lon + "<br><br><br><br><br><br>Click to copy RGB-value.</div></span>";

                 } else {

                    document.getElementById( "allGreenWrapper" ).innerHTML += "<span onclick='" + copyToClipboard( "R:" + window["sessionGreens"][i].rgb.r + ", G:"  + window["sessionGreens"][i].rgb.g + ", B:" + window["sessionGreens"][i].rgb.b ) + "' class='roundCorners roundCornersTextOverlays' style='width:24.4%;float:left;margin-right:4px;background:rgb(" + window["sessionGreens"][i].rgb.r + "," +  window["sessionGreens"][i].rgb.g +  "," + window["sessionGreens"][i].rgb.b + ")'><div class='showOnHover'>" + window["sessionGreens"][i].address + "<br>Lat: " +  window["sessionGreens"][i].lat + "<br>Lon: " + window["sessionGreens"][i].lon + "<br><br><br><br><br><br>Click to copy RGB-value.</div></span>";
                 
                 }

            }

            document.getElementById( "allGreenWrapper" ).innerHTML += "<br><br><br><br><br>";
                 

            TweenMax.to( document.getElementById( "allGreenResults" ), 0.5, { autoAlpha: 1, ease:Sine.easeOut, onComplete:function() {


            } } );

        } } );

    } );          

    document.addEventListener("closeGreens", (e) => {
        
        document.getElementById( "resultsPos" ).style.display = "none";

        TweenMax.to( document.getElementById( "allGreenResults" ), 0.5, { autoAlpha: 0, ease:Expo.easeOut, onComplete:function() {

            document.getElementById( "allGreenResults" ).style.display = "none";
            document.getElementById( "n03input" ).style.display = "";
            document.getElementById( "greenQuestion" ).style.display = "none";
            document.getElementById( "greenThanks" ).style.display = "none";    
            document.getElementById( "greenResult" ).style.display = "none";  
            document.getElementById( "greenResultText" ).style.display = "none";            
            TweenMax.to( document.getElementById( "n03input" ), 0.5, { autoAlpha: 1, ease:Sine.easeOut });

        } } );

        document.getElementById( "mobileResultWrapper" ).style.display = "none";
                                
        let ground = null;
        let ground1 = null;

        for( let i=_self.groundObj.children.length-1; i >= 0; i-- ) {

             let getMesh = _self.groundObj.children[i];
             
             if( getMesh.name.indexOf( "ground", 0) === -1 ) {

                 if( getMesh.userData.y ) {

                     var initial = new THREE.Color(getMesh.material.color);
                     var value = new THREE.Color( 0xDDDDDD );
                      
                     TweenMax.to(initial, 1, {
                        r: value.r,
                        g: value.g,
                        b: value.b,
                        ease:Sine.easeOut,
                        delay:0.5,

                        onUpdate: function () {
                          getMesh.material.color = initial;
                        }

                     });

                     TweenMax.to( getMesh.position, 1.8 + Math.random() * 1.0, { y: getMesh.userData.y, ease:Sine.easeOut });
                     TweenMax.to( getMesh.rotation, 1.8 + Math.random() * 1.0, { x:getMesh.userData.rx, y: getMesh.userData.ry, ease:Sine.easeOut });

                 }

             } else {

                  if( typeof ground === 'undefined' || ground === null ) {

                      ground = _self.groundObj.children[i];

                   } else {

                      ground1 = _self.groundObj.children[i];

                   }

             }
        
        }

        TweenMax.to( ground.position, 1.0, { y:-1.95, ease:Expo.easeOut });
        TweenMax.to( ground.material, 0.5, { opacity:1.0, ease:Expo.easeOut });
        TweenMax.to( ground1.material, 0.5, { opacity:1.0, ease:Expo.easeOut });   
        TweenMax.to( _self.equiMap.material, 0.5, { opacity:1.0, ease:Expo.easeOut });
        TweenMax.to( _self.gridMat.uniforms.alphaValue, 0.5, { value:0.0, ease:Expo.easeOut, onComplete:function() {
            _self.scene.remove( _self.gridBase );
        }  });
    
    } );

    document.addEventListener("closeVideoBtn", (e) => {
        
        TweenMax.to( this.simpleSaturationPass.uniforms.adjust, 0.25, { value:2.4 } );

        this.video.pause();
        this.video.currentTime = 0;


        _self.moviePlane.material = _self.moviePlane.userData.shaded;        
        //this.videoObj.visible = false;
        //this.moviePlane.material = this.moviePlane.userData.movieMaterial;
        //this.moviePlane.userData = { isNormal:true, material:movieBlankMaterial, moviematerial:movieMaterial, uniforms:movieMaterial.uniforms };
        document.getElementById( "closeVideo" ).style.display = "none";

    } );

    document.addEventListener("pauseVideoBtn", (e) => {
        
        
        //TweenMax.to( this.simpleSaturationPass.uniforms.adjust, 0.25, { value:2.4 } );
        if( document.getElementById( "pauseVideoBtn" ).src.toString().indexOf( "Stop", 0 ) !== -1 ) {

            this.video.pause();
            document.getElementById( "pauseVideoBtn" ).src = "./look/PlayButtonBlack.png";

        } else {

            document.getElementById( "pauseVideoBtn" ).src = "./look/StopButtonBlack.png";
            this.video.play();

        }

    } );


    document.addEventListener("muteVideoBtn", (e) => {
        
        if( !this.video.muted ) {
        
            this.video.muted = true;
            document.getElementById( "muteVideoBtn" ).src = "./look/NoAudioButtonBlack.png";

        }  else {

            this.video.muted = false;
            document.getElementById( "muteVideoBtn" ).src = "./look/AudioButtonBlack.png";

        }


    } );

    document.addEventListener("coockiesYes", (e) => {

        var date = new Date();
        date.setTime(date.getTime()+(20*24*60*60*1000));
        document.cookie = "greenfingerprint" + "=" + "yes" + "; expires=" + date.toGMTString() /*+ 'path=' + path + 'domain=' + domain*/;

        document.getElementById( "noExperience" ).style.display = "none";
        TweenMax.to( document.getElementById( "coockies" ), 0.5, { autoAlpha: 0, ease:Expo.easeOut });

        window["iUseCookies"] = true;  

        _self.coockies = true;

    } );


    document.addEventListener("coockiesNo", (e) => {
        
        document.getElementById( "noExperience" ).style.display = "none";
        TweenMax.to( document.getElementById( "coockies" ), 0.5, { autoAlpha: 0, ease:Expo.easeOut });
        //document.getElementById( "noExperience" ).style.display = "block";
        //TweenMax.to( document.getElementById( "noExperience" ), 0.5, { autoAlpha: 1, ease:Sine.easeOut });

        const clearCookies = document.cookie.split(';').forEach(cookie => document.cookie = cookie.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`));

        // Remove the default tracker.
        if (window.ga) window.ga('remove');
        // Remove the default cookies
        // _ga is used to distinguish users.
        Cookies.remove('_ga', { path: '/', domain: document.domain });
        // _gid is used to distinguish users.
        Cookies.remove('_gid', { path: '/', domain: document.domain });
        // _gat is used to throttle request rate.
        Cookies.remove('_gat', { path: '/', domain: document.domain });  

        window["iUseCookies"] = false;       
        
        _self.coockies = true;


    } );

    const getCookieValue = () => {
        
        var cookieValue = document.cookie.match('(^|;)\\s*' + "greenfingerprint" + '\\s*=\\s*([^;]+)');
        
        if( cookieValue ) {

            if ( cookieValue.pop() === "yes" ) {
                 
                 _self.coockies = true;
                 document.getElementById("coockies").style.display = "none";

                 window["iUseCookies"] = true; 
                 
            }

        }

    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const cid = urlParams.get('cid');

    if( !cid ) {

        getCookieValue();

    } else {

        if( cid === "1" ) {

            getCookieValue();
            
        } else {
            
            _self.coockies = true;
            document.getElementById("coockies").style.display = "none";

            window["iUseCookies"] = true; 

        }

    }

    document.addEventListener("navi04", (e) => {

        if( !_self.coockies ) return;
        if( _self.markerIsSet ) return;

        document.getElementById( "mobileResultWrapper" ).style.display = "none";

        this.groundObj.remove( this.moviePlane );
        this.groundObj.remove( this.model_bambi );
        this.groundObj.remove( this.model_deer );

        this.video.pause();
        this.video.currentTime = 0;
        this.moviePlane.material = _self.moviePlane.userData.shaded; 
        document.getElementById( "closeVideo" ).style.display = "none";

        TweenMax.to( this.simpleSaturationPass.uniforms.adjust, 0.25, { value:2.4 } );

        if( _self.topic === 3 ) {

            let ground = null;
            let ground1 = null;

            for( let i=_self.groundObj.children.length-1; i >= 0; i-- ) {

                 let getMesh = _self.groundObj.children[i];
                 
                 if( getMesh.name.indexOf( "ground", 0) === -1 ) {

                     if( getMesh.userData.y ) {

                         var initial = new THREE.Color(getMesh.material.color);
                         var value = new THREE.Color( 0xDDDDDD );
                          
                         TweenMax.to(initial, 1, {
                            r: value.r,
                            g: value.g,
                            b: value.b,
                            ease:Sine.easeOut,
                            delay:0.5,

                            onUpdate: function () {
                              getMesh.material.color = initial;
                            }

                         });

                         TweenMax.to( getMesh.position, 1.8 + Math.random() * 1.0, { y: getMesh.userData.y, ease:Sine.easeOut });
                         TweenMax.to( getMesh.rotation, 1.8 + Math.random() * 1.0, { x:getMesh.userData.rx, y: getMesh.userData.ry, ease:Sine.easeOut });
                     }

                 } else {

                      if( typeof ground === 'undefined' || ground === null ) {

                          ground = _self.groundObj.children[i];

                       } else {

                          ground1 = _self.groundObj.children[i];

                       }

                 }
            
            }
    
            TweenMax.to( ground.position, 1.0, { y:-1.95, ease:Expo.easeOut });
            TweenMax.to( ground.material, 0.5, { opacity:1.0, ease:Expo.easeOut });
            TweenMax.to( ground1.material, 0.5, { opacity:1.0, ease:Expo.easeOut });   
            TweenMax.to( _self.equiMap.material, 0.5, { opacity:1.0, ease:Expo.easeOut });
            TweenMax.to( _self.gridMat.uniforms.alphaValue, 0.5, { value:0.0, ease:Expo.easeOut, onComplete:function() {
                _self.scene.remove( _self.gridBase );
            }  });
        }

        document.getElementById( "navi01" ).className = "";
        document.getElementById( "navi01" ).className = "isNormal";
        document.getElementById( "navi01nr" ).className = "";
        document.getElementById( "navi01nr" ).className = "isNormalNumber";  

        document.getElementById( "navi02" ).className = "";
        document.getElementById( "navi02" ).className = "isNormal";
        document.getElementById( "navi02nr" ).className = "";  
        document.getElementById( "navi02nr" ).className = "isNormalNumber";  

        document.getElementById( "navi03" ).className = "";
        document.getElementById( "navi03" ).className = "isNormal";
        document.getElementById( "navi03nr" ).className = "";
        document.getElementById( "navi03nr" ).className = "isNormalNumber"; 

        document.getElementById( "navi04" ).className = "";
        document.getElementById( "navi04" ).className = "isItalic";
        document.getElementById( "navi04nr" ).className = "";
        document.getElementById( "navi04nr" ).className = "naviNumberActive";  

        document.getElementById( "navi05" ).className = "";
        document.getElementById( "navi05" ).className = "isNormal";
        document.getElementById( "navi05nr" ).className = "";
        document.getElementById( "navi05nr" ).className = "isNormalNumber"; 

        document.getElementById( "n03input" ).style.display = "";
        TweenMax.to( document.getElementById( "n03input" ), 0.5, { autoAlpha: 0 });
        document.getElementById( "allGreenResults" ).style.display = "none";
        document.getElementById( "greenQuestion" ).style.display = "none";
        document.getElementById( "greenThanks" ).style.display = "none";    
        document.getElementById( "greenResult" ).style.display = "none";  
        document.getElementById( "greenResultText" ).style.display = "none";

        TweenMax.to(".n01", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });
        TweenMax.to(".n02", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });
        TweenMax.to(".n03", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });
        TweenMax.to(".n04", 0.85, {left:"10px", opacity:"1.0", ease:Bounce.easeOut });
        TweenMax.to(".n05", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });

        let camMoveToPos = new THREE.Vector3( 22, 0.4278823748442191, -25 );

        _self.topic = 4;
        window["topic"] = 4;

        if( !_self.moviePlane.userData.isNormal ) {

            _self.moviePlane.material = _self.moviePlane.userData.material;
            _self.moviePlane.userData.isNormal = true;

        }

        if( !_self.markerIsSet ) moveCamTo( camMoveToPos, 1.6, -15.0 );

        _self.markerIsSet = true;

        TweenMax.to( document.getElementById('alltext'), 0.75, { autoAlpha:0, onComplete:function() {

            document.getElementById('txtnr01').style.display = "none";
            document.getElementById('txtnr02').style.display = "none";
            document.getElementById('txtnr03').style.display = "none";
            document.getElementById('txtnr04').style.display = "block";
            document.getElementById('txtnr05').style.display = "none";

            TweenMax.to( document.getElementById('alltext'), 0.75, { autoAlpha:1 } );

        } } );

    } );



    document.addEventListener("navi05", (e) => {

        if( !_self.coockies ) return;
        if( _self.markerIsSet ) return;

        document.getElementById( "mobileResultWrapper" ).style.display = "none";

        this.groundObj.remove( this.moviePlane );
        this.groundObj.remove( this.model_bambi );
        this.groundObj.remove( this.model_deer );

        this.video.pause();
        this.video.currentTime = 0;
        this.moviePlane.material = _self.moviePlane.userData.shaded; 
        document.getElementById( "closeVideo" ).style.display = "none";

        TweenMax.to( this.simpleSaturationPass.uniforms.adjust, 0.25, { value:2.4 } );

        if( _self.topic === 3 ) {

            let ground = null;
            let ground1 = null;

            for( let i=_self.groundObj.children.length-1; i >= 0; i-- ) {

                 let getMesh = _self.groundObj.children[i];
                 
                 if( getMesh.name.indexOf( "ground", 0) === -1 ) {

                     if( getMesh.userData.y ) {

                         var initial = new THREE.Color(getMesh.material.color);
                         var value = new THREE.Color( 0xDDDDDD );
                          
                         TweenMax.to(initial, 1, {
                            r: value.r,
                            g: value.g,
                            b: value.b,
                            ease:Sine.easeOut,
                            delay:0.5,

                            onUpdate: function () {
                              getMesh.material.color = initial;
                            }

                         });

                         TweenMax.to( getMesh.position, 1.8 + Math.random() * 1.0, { y: getMesh.userData.y, ease:Sine.easeOut });
                         TweenMax.to( getMesh.rotation, 1.8 + Math.random() * 1.0, { x:getMesh.userData.rx, y: getMesh.userData.ry, ease:Sine.easeOut });
                     }

                 } else {

                      if( typeof ground === 'undefined' || ground === null ) {

                          ground = _self.groundObj.children[i];

                       } else {

                          ground1 = _self.groundObj.children[i];

                       }

                 }
            
            }
    
            TweenMax.to( ground.position, 1.0, { y:-1.95, ease:Expo.easeOut });
            TweenMax.to( ground.material, 0.5, { opacity:1.0, ease:Expo.easeOut });
            TweenMax.to( ground1.material, 0.5, { opacity:1.0, ease:Expo.easeOut });   
            TweenMax.to( _self.equiMap.material, 0.5, { opacity:1.0, ease:Expo.easeOut });
            TweenMax.to( _self.gridMat.uniforms.alphaValue, 0.5, { value:0.0, ease:Expo.easeOut, onComplete:function() {
                _self.scene.remove( _self.gridBase );
            }  });
        }

        document.getElementById( "navi01" ).className = "";
        document.getElementById( "navi01" ).className = "isNormal";
        document.getElementById( "navi01nr" ).className = "";
        document.getElementById( "navi01nr" ).className = "isNormalNumber";  

        document.getElementById( "navi02" ).className = "";
        document.getElementById( "navi02" ).className = "isNormal";
        document.getElementById( "navi02nr" ).className = "";  
        document.getElementById( "navi02nr" ).className = "isNormalNumber";  

        document.getElementById( "navi03" ).className = "";
        document.getElementById( "navi03" ).className = "isNormal";
        document.getElementById( "navi03nr" ).className = "";
        document.getElementById( "navi03nr" ).className = "isNormalNumber"; 

        document.getElementById( "navi04" ).className = "";
        document.getElementById( "navi04" ).className = "isNormal";
        document.getElementById( "navi04nr" ).className = "";
        document.getElementById( "navi04nr" ).className = "isNormalNumber";  

        document.getElementById( "navi05" ).className = "";
        document.getElementById( "navi05" ).className = "isItalic";
        document.getElementById( "navi05nr" ).className = "";
        document.getElementById( "navi05nr" ).className = "naviNumberActive";  

        document.getElementById( "n03input" ).style.display = "";
        TweenMax.to( document.getElementById( "n03input" ), 0.5, { autoAlpha: 0 });
        document.getElementById( "allGreenResults" ).style.display = "none";
        document.getElementById( "greenQuestion" ).style.display = "none";
        document.getElementById( "greenThanks" ).style.display = "none";    
        document.getElementById( "greenResult" ).style.display = "none";  
        document.getElementById( "greenResultText" ).style.display = "none";

        TweenMax.to(".n01", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });
        TweenMax.to(".n02", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });
        TweenMax.to(".n03", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });
        TweenMax.to(".n04", 0.85, {left:"5px", opacity:"0.65", ease:Bounce.easeOut });
        TweenMax.to(".n05", 0.85, {left:"10px", opacity:"1.0", ease:Bounce.easeOut });

        let camMoveToPos = new THREE.Vector3( 12, 0.4278823748442191, -15 );

        _self.topic = 5;
        window["topic"] = 5;

        if( !_self.moviePlane.userData.isNormal ) {

            _self.moviePlane.material = _self.moviePlane.userData.material;
            _self.moviePlane.userData.isNormal = true;

        }

        if( !_self.markerIsSet ) moveCamTo( camMoveToPos, -1.0, -12.0 );

        _self.markerIsSet = true;

        TweenMax.to( document.getElementById('alltext'), 0.75, { autoAlpha:0, onComplete:function() {

            document.getElementById('txtnr01').style.display = "none";
            document.getElementById('txtnr02').style.display = "none";
            document.getElementById('txtnr03').style.display = "none";
            document.getElementById('txtnr04').style.display = "none";
            document.getElementById('txtnr05').style.display = "block";

            TweenMax.to( document.getElementById('alltext'), 0.75, { autoAlpha:1 } );

        } } );

    } );




    ////////////////////////////////////////////////////////////////////
    // navigation animtaion(s)   ///////////////////////////////////////
    // and behaviour(s)          ///////////////////////////////////////
    ////////////////////////////////////////////////////////////////////

    TweenMax.to( document.getElementById( "n03input" ), 0.01, { autoAlpha: 0 });
    TweenMax.to( document.getElementById( "greenResult" ), 0.01, { autoAlpha: 0, onComplete:function() { document.getElementById( "greenResult" ).style.display = "none"; } } );
    TweenMax.to( document.getElementById( "greenResultText" ), 0.01, { autoAlpha: 0, onComplete:function() { 
        document.getElementById( "greenResultText" ).style.display = "none"; 
        document.getElementById( "centeredBox" ).style.display = "flex";
    } } );
    TweenMax.to( document.getElementById( "greenThanks" ), 0.01, { autoAlpha: 0, onComplete:function() { 
        document.getElementById( "greenThanks" ).style.display = "none"; 
    } } );  
    TweenMax.to( document.getElementById( "allGreenResults" ), 0.01, { autoAlpha: 0, onComplete:function() { 
        document.getElementById( "allGreenResults" ).style.display = "none"; 
    } } );  

    TweenMax.to( document.getElementById('alltext'), 1.5, { delay:0.4, autoAlpha:1 } );


    let tl = new TimelineMax({repeat: -1});
    tl.to(".n01", 2 + Math.floor( Math.random() * 4 ), {
                         x: Math.floor( 20 + Math.random() * 26 ),
                         y: Math.floor( -6 + Math.random() * 12 ),
                         onComplete: function() {
                                this.vars.css.x = Math.floor( 20 + Math.random() * 26 );
                                this.vars.css.y = Math.floor( -6 + Math.random() * 12 );
                                this.invalidate();
                         }
    });

    let tl2 = new TimelineMax({repeat: -1});
    tl2.to(".n02", 2 + Math.floor( Math.random() * 4 ), {
                         x: Math.floor( 20 + Math.random() * 26 ),
                         y: Math.floor( -6 + Math.random() * 16 ),
                         onComplete: function() {
                                this.vars.css.x = Math.floor( 20 + Math.random() * 26 );
                                this.vars.css.y = Math.floor( -6 + Math.random() * 12 );
                                this.invalidate();
                         }
    });

    let tl3 = new TimelineMax({repeat: -1});
    tl3.to(".n03", 2 + Math.floor( Math.random() * 4 ), {
                         x: Math.floor( 20 + Math.random() * 26 ),
                         y: Math.floor( -6 + Math.random() * 12 ),
                         onComplete: function() {
                                this.vars.css.x = Math.floor( 20 + Math.random() * 26 );
                                this.vars.css.y = Math.floor( -6 + Math.random() * 12 );
                                this.invalidate();
                         }
    });  

    let tl4 = new TimelineMax({repeat: -1});
    tl4.to(".n04", 2 + Math.floor( Math.random() * 4 ), {
                         x: Math.floor( 20 + Math.random() * 26 ),
                         y: Math.floor( -6 + Math.random() * 12 ),
                         onComplete: function() {
                                this.vars.css.x = Math.floor( 20 + Math.random() * 26 );
                                this.vars.css.y = Math.floor( -6 + Math.random() * 12 );
                                this.invalidate();
                         }
    });        

    let tl5 = new TimelineMax({repeat: -1});
    tl5.to(".n05", 2 + Math.floor( Math.random() * 4 ), {
                         x: Math.floor( 20 + Math.random() * 26 ),
                         y: Math.floor( -6 + Math.random() * 12 ),
                         onComplete: function() {
                                this.vars.css.x = Math.floor( 20 + Math.random() * 26 );
                                this.vars.css.y = Math.floor( -6 + Math.random() * 12 );
                                this.invalidate();
                         }
    }); 


    ////////////////////////////////////////////////////////////////////
    // setup:                    ///////////////////////////////////////
    // mouse input vars          ///////////////////////////////////////
    ////////////////////////////////////////////////////////////////////

    this.mouse       = new THREE.Vector2();
    this.mouseTarget = new THREE.Vector2();
    this.windowHalf  = new THREE.Vector2( this.container.offsetWidth / 2, this.container.offsetHeight / 2 );
    
    document.addEventListener( 'mousemove', function( event ) {

        _self.mouse.x = ( event.clientX - _self.windowHalf.x );
        _self.mouse.y = ( event.clientY - _self.windowHalf.y );

    }, false );

    this.raycaster = new THREE.Raycaster();

    function checkIntersection(x, y, mouseState) {

        _self.mouse.x = (x / window.innerWidth) * 2 - 1;
        _self.mouse.y = -(y / window.innerHeight) * 2 + 1;

        _self.raycaster.setFromCamera(_self.mouse, _self.camera);

        const intersects = _self.raycaster.intersectObject( _self.scene, true );

        if( intersects.length > 0 ) {

            for( let i = 0; i <= intersects.length-1; i++ ) {

                if( intersects[i].object.name === "movie" && _self.topic === 2 /*&& !_self.videoObj.visible*/ ) {

                    TweenMax.to( _self.simpleSaturationPass.uniforms.adjust, 0.25, { value:1.0 } );

                    _self.moviePlane.userData.shaded = _self.moviePlane.material;
                    _self.moviePlane.material = new THREE.MeshBasicMaterial({ map:_self.texturev, side:THREE.BackSide } );
                    _self.video.play();

                    _self.video.muted = false;

                    document.getElementById( "pauseVideoBtn" ).src = "./look/StopButtonBlack.png";
                    document.getElementById( "muteVideoBtn" ).src = "./look/AudioButtonBlack.png";
                    document.getElementById('closeVideo').style.display = "inline-block";
                    TweenMax.to( document.getElementById('alltext'), 0.5, { autoAlpha:0 } );

                }
            } 

        }
        /*for ( let i = 0; i < intersectObjectsects.length; i ++ ) {

             console.log( intersects[ i ].name )
            //intersects[ i ].object.material.color.set( 0xff0000 );

        }        
/*
        const intersects = _self.raycaster.intersectObject( _self.scene, true );

        if (intersects.length > 0) {

            //const res = intersects.filter(function (res) {
              return res && res.object;
            })[0];

            if ( res && res.object && res.object.name === "movie" ) {

                self.videoObj.visible = true;
                self.video.play();

                document.getElementById('closeVideo').style.display = "inline-block";
                TweenMax.to( document.getElementById('alltext'), 0.5, { autoAlpha:0 } );

            }
        }*/
    }

    document.addEventListener( 'pointerdown', event => {

        if( !this.coockies ) return;
        checkIntersection(parseInt(event.clientX), parseInt(event.clientY));

    }, false );

    window.addEventListener( 'wheel',  function( event ) { 

       // console.log( event.deltaY );
        if( _self.markerIsSet ) return;

        if ( event.deltaY > 0 ) {

             window["setOnScroll"]( _self.topic, "down" );

        } else {

             window["setOnScroll"]( _self.topic, "up" );
        
        }
        
    }, false ); 



    let touchstartX = 0;
    let touchendX = 0;
    let touchstartY = 0;
    let touchendY = 0;


    function handleGesture() {
      if (touchendY < touchstartY) window["setOnScroll"]( _self.topic, "up" );
      if (touchendY > touchstartY) window["setOnScroll"]( _self.topic, "down" );
    }

    window.addEventListener('touchstart', e => {
      touchstartX = e.changedTouches[0].screenX;
      touchstartY = e.changedTouches[0].screenY
    })

    window.addEventListener('touchend', e => {
      touchendX = e.changedTouches[0].screenX;
      touchendY = e.changedTouches[0].screenY
      handleGesture()
    })
    
    ////////////////////////////////////////////////////////////////////
    // resize & run:         ///////////////////////////////////////////
    // render-loop           ///////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////

    this.resize();
    this.renderFrame();

    console.log( this.renderer.info );

    this.isRunning = true;



    if( this.devMobile ) {

        let timerid = setTimeout(() => {
        
            var rect = document.getElementById( "alltext" ).getBoundingClientRect();

            document.getElementById( "alltext" ).style.width = window["width"] + "px";
            document.getElementById( "alltext" ).style.bottom =  0   + "px";
            document.getElementById( "alltext" ).style.paddingRight = "";
            document.getElementById( "alltext" ).style.paddingLeft = "";
            document.getElementById( "alltext" ).style.paddingBottom = "";
            document.getElementById( "alltext" ).style.paddingTop = "";
            document.getElementById( "alltext" ).style.left = "0px";
            document.getElementById( "alltext" ).style.right = "";
            document.getElementById( "alltext" ).style.fontSize = "13px";


            document.getElementById( "coockies" ).style.height = "200px";
            document.getElementById( "coockiesText" ).style.width = "80%";
            document.getElementById( "coockiesText" ).className = "coockiesTextMobile";
            document.getElementById( "coockiesText").innerHTML = "<br><br><b>We use cookies</b>(<a href='./OverlayWebsitePolicies.html' target='_blank'>read more about it</a>) - Please, accept to continue enjoying the experience!<br><br><br><span id='yesCoockiesButton' class='curveButton'>Yes</span><span id='noCoockiesButton' class='curveButton curveButtonRed'>No</span>";

            let coockiesYes = new CustomEvent("coockiesYes", { detail: "" });
            let coockiesNo = new CustomEvent("coockiesNo", { detail: "" });   

            document.getElementById( "yesCoockiesButton" ).onclick = function() {
        
                document.dispatchEvent( coockiesYes );      
      
            }; 

            document.getElementById( "noCoockiesButton" ).onclick = function() {
            
                document.dispatchEvent( coockiesNo );      
          
            }; 

            document.getElementById( "noCoockiesButton" ).onclick = function() {
            
                document.dispatchEvent( coockiesNo );      
          
            };  


            document.getElementById( "greenResult" ).style.marginTop = "100px";  

        }, 1 );

    }

  }

  updateCameraOrbit() {
     let forward = new THREE.Vector3();
     this.camera.getWorldDirection(forward);
     this.controls.target.copy(this.camera.position).add(forward);
  }

  /* ---------------------------------------------------------------------------------------------------------------------- */
  /* -- setup: grass ------------------------------------------------------------------------------------------------------ */
  /* ---------------------------------------------------------------------------------------------------------------------- */
  getNoise( x, y, z, t ) {
    
  //  var y = 2*noise.simplex2(x/100, z/100);
  //  y += 1*noise.simplex2(x/150, z/150);
  //  y += 0.1*noise.simplex2(x/20, z/20);
   return noise.simplex3(x, y, z, t);
    
   // return y;

  }



  /* ---------------------------------------------------------------------------------------------------------------------- */
  /* -- setup: ground ----------------------------------------------------------------------------------------------------- */
  /* ---------------------------------------------------------------------------------------------------------------------- */

  setupGround( groundObj ) {
    
    var _self = this;

    noise.seed(5);

    let gtexture = this.state.textureArray[5][1];
    gtexture.anisotropy = 16;
    gtexture.wrapS = THREE.RepeatWrapping;
    gtexture.wrapT = THREE.RepeatWrapping;
    gtexture.repeat.set(20, 20);

    let ntexture = this.state.textureArray[3][1];
    ntexture.anisotropy = 16;
    ntexture.wrapS = THREE.RepeatWrapping;
    ntexture.wrapT = THREE.RepeatWrapping;
    ntexture.repeat.set(20, 20);


    var ground_geometry = new THREE.PlaneGeometry( this.areaWidth * 4, this.areaWidth * 4, 32 * 4, 32 * 4);
    ground_geometry.lookAt(new THREE.Vector3(0,1,0));
    ground_geometry.verticesNeedUpdate = true;
    var ground_material = new THREE.MeshStandardMaterial({ color: 0xFFFFFF, emissive:0xFFFFFF, emissiveIntensity:0.8, roughness:0.7, metalness:1.1, map:gtexture, normalMap:ntexture, normalScale:new THREE.Vector2(-1, -1), aoMap:gtexture, aoMapIntensity:1.0, transparent:true, flatShading: true });
    var ground = new THREE.Mesh(ground_geometry, ground_material);
    ground.name = "ground";

    ground.castShadow = true;
    ground.receiveShadow = true;


    var ground_geometry1 = new THREE.PlaneGeometry( this.areaWidth * 4, this.areaWidth * 4, 32 * 4, 32 * 4);
    ground_geometry1.lookAt(new THREE.Vector3(0,1,0));
    ground_geometry1.verticesNeedUpdate = true;
    var ground_material1 = new THREE.MeshStandardMaterial({color: 0xEFEFEF, emissive:0xFFFFFF, emissiveIntensity:0.8, roughness:0.7, metalness:1.1, map:gtexture, normalMap:ntexture, normalScale:new THREE.Vector2(-1, -1), aoMap:gtexture, aoMapIntensity:1.0, transparent:true, flatShading: true });
    var ground1 = new THREE.Mesh(ground_geometry1, ground_material1);
    ground1.name = "ground1";

    //var box = new THREE.BoxGeometry( 1, 1, 1 );
    var icosa = new THREE.IcosahedronGeometry(1, 0);
    var dodeca = new THREE.DodecahedronGeometry(1, 0);

    var boxmat = new THREE.MeshPhongMaterial({color: 0xDDDDDD, flatShading: true });

    for ( var i = 0; i < 1500; i++  ) {

          var bWidth = 0.05 + ( Math.random() * 0.3 );
          var box = new THREE.BoxGeometry( bWidth, 0.5 + Math.random() * 2, bWidth );
          var geom = null;
          if( parseInt( 0 + Math.random() * 2 ) === 0 ) {

              geom = dodeca;

          } else {

              geom = icosa;
          }


          
          var b = new THREE.Mesh(geom, boxmat);

          b.position.x = -50 + Math.random() * 100;
          b.position.y = -0.5 - ( Math.random() * 1.0 );
          b.position.z = -50 + Math.random() * 100;
          b.scale.set( 0.65, 0.65, 0.65 );

          b.rotation.y = -3.1 + Math.random() * 6.05;
          b.rotation.x = -3.1 + Math.random() * 6.05;
          b.castShadow = true;


          b.userData = { 
                            x:b.position.x,
                            y:b.position.y,
                            z:b.position.z,
                            rx:b.rotation.x,
                            ry:b.rotation.y,
                       };

          groundObj.add( b );
    }


    for ( var i = 0; i < ground.geometry.vertices.length; i++  ){
         
          var v = ground.geometry.vertices[i];
          var v1 = ground1.geometry.vertices[i];
 
                    v.x += Math.random() * 20 - 10;
                    v.y += Math.random() * 3;
                    v.z += Math.random() * 20 - 10;

                v1.y = this.getNoise(v1.x * 0.01, v1.y * 0.01, v1.z * 0.01, 0);
                v1.y += this.getNoise(v1.x * 0.03, v1.y * 0.03, v1.z * 0.03, 0) * 4.;
                v1.y += this.getNoise(v1.x * 0.1, v1.y * 0.125, v1.z * 0.125, 0);



    }


    var movieCanvas = new THREE.PlaneGeometry( 6, 3 );
    let xrayVertexSource = `
      
        varying vec2 vUv;
        uniform sampler2D movie;
        uniform vec2 resolution;
        uniform float iTime;

        void main() {
            vUv = uv; 

            vec4 modelViewPosition = modelViewMatrix * vec4(position, 1.0);
            gl_Position = projectionMatrix * modelViewPosition; 
        }

    `;


    let xrayFragmentSource = `
      

        #define BLACK_AND_WHITE
        //#define LINES_AND_FLICKER
        //#define BLOTCHES
        #define GRAIN

        #define FREQUENCY 15.0

        uniform sampler2D movie;
        uniform vec2 resolution;
        varying vec2 vUv;
        uniform float iTime;

        float rand(vec2 co){
            return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);
        }

        float rand(float c){
            return rand(vec2(c,1.0));
        }

        float randomLine(float seed)
        {
            float b = 0.01 * rand(seed);
            float a = rand(seed+1.0);
            float c = rand(seed+2.0) - 0.5;
            float mu = rand(seed+3.0);
            
            float l = 1.0;
            
            if ( mu > 0.2)
                l = pow(  abs(a * vUv.x + b * vUv.y + c ), 1.0/8.0 );
            else
                l = 2.0 - pow( abs(a * vUv.x + b * vUv.y + c), 1.0/8.0 );             
            
            return mix(0.5, 1.0, l);
        }

        // Generate some blotches.
        float randomBlotch(float seed)
        {
            float x = rand(seed);
            float y = rand(seed+1.0);
            float s = 0.01 * rand(seed+2.0);
            
            vec2 p = vec2(x,y) - vUv;
            p.x *= 1024.0 / 512.0;
            float a = atan(p.y,p.x);
            float v = 1.0;
            float ss = s*s * (sin(6.2831*a*x)*0.1 + 1.0);
            
            if ( dot(p,p) < ss ) v = 0.2;
            else
                v = pow(dot(p,p) - ss, 1.0/16.0);
            
            return mix(0.3 + 0.2 * (1.0 - (s / 0.02)), 1.0, v);
        }


        void main() {

            //uv = fragCoord.xy / iResolution.xy;

            // Set frequency of global effect to 15 variations per second
            float t = float(int(iTime * FREQUENCY));

            // Get some image movement
            vec2 suv = vUv + 0.002 * vec2( rand(t), rand(t + 23.0));

            // Get the image
            vec3 image = texture2D( movie, vUv ).xyz;
            
            //#ifdef BLACK_AND_WHITE
            // Convert it to B/W
            //float luma = dot( vec3(0.2126, 0.7152, 0.0722), image );
            //vec3 oldImage = luma * vec3(0.7, 0.7, 0.7);
            //#else
            vec3 oldImage = image;
            //#endif
            


            // Create a time-varying vignetting effect
            float vI = 1.0 * (vUv.x * (1.0-vUv.x) * vUv.y * (1.0-vUv.y));
            vI *= mix( 0.7, 1.0, rand(t + 0.5));
 
            // Add additive flicker
            vI += 2.0 /*+ 0.4 * rand(t+8.)*/;
            
            // Add a fixed vignetting (independent of the flicker)
            vI *= pow(1.0 * vUv.x * (1.0-vUv.x) * vUv.y * (1.0-vUv.y), 0.4);
            
            // Add some random lines (and some multiplicative flicker. Oh well.)
            #ifdef LINES_AND_FLICKER
            int l = int(8.0 * rand(t+7.0));
            
            if ( 0 < l ) vI *= randomLine( t+6.0+17.* float(0));
            if ( 1 < l ) vI *= randomLine( t+6.0+17.* float(1));
            if ( 2 < l ) vI *= randomLine( t+6.0+17.* float(2));        
            if ( 3 < l ) vI *= randomLine( t+6.0+17.* float(3));
            if ( 4 < l ) vI *= randomLine( t+6.0+17.* float(4));
            if ( 5 < l ) vI *= randomLine( t+6.0+17.* float(5));
            if ( 6 < l ) vI *= randomLine( t+6.0+17.* float(6));
            if ( 7 < l ) vI *= randomLine( t+6.0+17.* float(7));
            
            #endif
            
            // Add some random blotches.
            #ifdef BLOTCHES
            int s = int( max(8.0 * rand(t+18.0) -2.0, 0.0 ));

            if ( 0 < s ) vI *= randomBlotch( t+6.0+19.* float(0));
            if ( 1 < s ) vI *= randomBlotch( t+6.0+19.* float(1));
            if ( 2 < s ) vI *= randomBlotch( t+6.0+19.* float(2));
            if ( 3 < s ) vI *= randomBlotch( t+6.0+19.* float(3));
            if ( 4 < s ) vI *= randomBlotch( t+6.0+19.* float(4));
            if ( 5 < s ) vI *= randomBlotch( t+6.0+19.* float(5));
        
            #endif
        
            // Show the image modulated by the defects
            gl_FragColor = vec4( mix( oldImage * vI, vec3(1.0), 0.5), 1.0 );
            
            // Add some grain (thanks, Jose!)
            #ifdef GRAIN
            gl_FragColor.xyz *= (1.0+(rand(vUv+t*.01)-.2)*.15);     
            #endif      


        }

    `;    

    let movieMaterial = new THREE.ShaderMaterial(
    {
        uniforms: {
            movie: { value: this.state.textureArray[18][1]},
            iTime: {type: 'float', value: 0.5}
        },
        vertexShader: xrayVertexSource,
        fragmentShader: xrayFragmentSource,
        side: THREE.DoubleSide,
        transparent: true,
        depthWrite: false,
        side:THREE.DoubleSide
    });

    let movieBlankMaterial = new THREE.MeshBasicMaterial({ color:new THREE.Color(0xBBBBBB), side:THREE.DoubleSide });
    this.moviePlane = new THREE.Mesh( movieCanvas, movieBlankMaterial );
    this.moviePlane.userData = { isNormal:true, material:movieBlankMaterial, moviematerial:movieMaterial, uniforms:movieMaterial.uniforms, shaded:movieMaterial };
    this.moviePlane.name = "movie";

    this.moviePlane.position.x = -15;
    this.moviePlane.position.y = 0.85;
    this.moviePlane.position.z = 12;
    this.moviePlane.rotation.y = 0.3;
    this.moviePlane.castShadow = true;

    ground.position.y -= 1.0;
    ground1.position.y -= 1.95;
    ground.geometry.computeVertexNormals();
    //ground1.geometry.computeVertexNormals();
    groundObj.add(ground);
    groundObj.add(ground1);
    this.scene.add( groundObj )


    ////////////////////////////////////////////////////////////////////
    // add:             ////////////////////////////////////////////////
    // model(s)         ////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////
    
    this.groundObj.add( this.model_bambi );

    this.model_bambi.name = "horses_bambi";
    this.model_bambi.position.x = -13.2;
    this.model_bambi.position.y = 0.0;
    this.model_bambi.position.z = 9;
    this.model_bambi.rotation.y = 1.6;
    this.model_bambi.scale.set( 0.15, 0.15, 0.15 );


    
    this.groundObj.add( this.model_deer );

    this.model_deer.name = "horses_deer";
    this.model_deer.position.x = -17.6;
    this.model_deer.position.y = -0.65;
    this.model_deer.position.z = 10.5;
    this.model_deer.rotation.y = 2.1;
    this.model_deer.scale.set( 0.15, 0.15, 0.15 );    


    this.gridBase = new THREE.Object3D();


    let gridVertexSource = `
      
          #define M_PI 3.1415926535897932384626433832795
          vec3 mod289(vec3 x)
          {
              return x - floor(x * (1.0 / 289.0)) * 289.0;
          }
          vec4 mod289(vec4 x)
          {
              return x - floor(x * (1.0 / 289.0)) * 289.0;
          }
          vec4 permute(vec4 x)
          {
              return mod289(((x*34.0)+1.0)*x);
          }
          vec4 taylorInvSqrt(vec4 r)
          {
              return 1.79284291400159 - 0.85373472095314 * r;
          }
          vec3 fade(vec3 t) {
              return t*t*t*(t*(t*6.0-15.0)+10.0);
          }
          float pnoise(vec3 P, vec3 rep)
          {
              vec3 Pi0 = mod(floor(P), rep);
              vec3 Pi1 = mod(Pi0 + vec3(1.0), rep);
              Pi0 = mod289(Pi0);
              Pi1 = mod289(Pi1);
              vec3 Pf0 = fract(P);
              vec3 Pf1 = Pf0 - vec3(1.0);
              vec4 ix = vec4(Pi0.x, Pi1.x, Pi0.x, Pi1.x);
              vec4 iy = vec4(Pi0.yy, Pi1.yy);
              vec4 iz0 = Pi0.zzzz;
              vec4 iz1 = Pi1.zzzz;
              vec4 ixy = permute(permute(ix) + iy);
              vec4 ixy0 = permute(ixy + iz0);
              vec4 ixy1 = permute(ixy + iz1);
              vec4 gx0 = ixy0 * (1.0 / 7.0);
              vec4 gy0 = fract(floor(gx0) * (1.0 / 7.0)) - 0.5;
              gx0 = fract(gx0);
              vec4 gz0 = vec4(0.5) - abs(gx0) - abs(gy0);
              vec4 sz0 = step(gz0, vec4(0.0));
              gx0 -= sz0 * (step(0.0, gx0) - 0.5);
              gy0 -= sz0 * (step(0.0, gy0) - 0.5);
              vec4 gx1 = ixy1 * (1.0 / 7.0);
              vec4 gy1 = fract(floor(gx1) * (1.0 / 7.0)) - 0.5;
              gx1 = fract(gx1);
              vec4 gz1 = vec4(0.5) - abs(gx1) - abs(gy1);
              vec4 sz1 = step(gz1, vec4(0.0));
              gx1 -= sz1 * (step(0.0, gx1) - 0.5);
              gy1 -= sz1 * (step(0.0, gy1) - 0.5);
              vec3 g000 = vec3(gx0.x,gy0.x,gz0.x);
              vec3 g100 = vec3(gx0.y,gy0.y,gz0.y);
              vec3 g010 = vec3(gx0.z,gy0.z,gz0.z);
              vec3 g110 = vec3(gx0.w,gy0.w,gz0.w);
              vec3 g001 = vec3(gx1.x,gy1.x,gz1.x);
              vec3 g101 = vec3(gx1.y,gy1.y,gz1.y);
              vec3 g011 = vec3(gx1.z,gy1.z,gz1.z);
              vec3 g111 = vec3(gx1.w,gy1.w,gz1.w);
              vec4 norm0 = taylorInvSqrt(vec4(dot(g000, g000), dot(g010, g010), dot(g100, g100), dot(g110, g110)));
              g000 *= norm0.x;
              g010 *= norm0.y;
              g100 *= norm0.z;
              g110 *= norm0.w;
              vec4 norm1 = taylorInvSqrt(vec4(dot(g001, g001), dot(g011, g011), dot(g101, g101), dot(g111, g111)));
              g001 *= norm1.x;
              g011 *= norm1.y;
              g101 *= norm1.z;
              g111 *= norm1.w;
              float n000 = dot(g000, Pf0);
              float n100 = dot(g100, vec3(Pf1.x, Pf0.yz));
              float n010 = dot(g010, vec3(Pf0.x, Pf1.y, Pf0.z));
              float n110 = dot(g110, vec3(Pf1.xy, Pf0.z));
              float n001 = dot(g001, vec3(Pf0.xy, Pf1.z));
              float n101 = dot(g101, vec3(Pf1.x, Pf0.y, Pf1.z));
              float n011 = dot(g011, vec3(Pf0.x, Pf1.yz));
              float n111 = dot(g111, Pf1);
              vec3 fade_xyz = fade(Pf0);
              vec4 n_z = mix(vec4(n000, n100, n010, n110), vec4(n001, n101, n011, n111), fade_xyz.z);
              vec2 n_yz = mix(n_z.xy, n_z.zw, fade_xyz.y);
              float n_xyz = mix(n_yz.x, n_yz.y, fade_xyz.x);
              return 2.2 * n_xyz;
          }  

      
          uniform float time;
          uniform float speed;
          uniform float sine_amplitude;
          uniform float noise_amplitude;
          uniform float perlin_passes;
          uniform float main_wave_amplitude;
          uniform float main_wave_frequency;

          varying vec2  v_uv;
          varying float z;
          
          #define M_PI 3.1415926535897932384626433832795
          #define H_PI M_PI * .5

          void main() {

              v_uv          = uv;//fract( uv + vec2( 0., time ) );

              float displacement  = pnoise( .4 * position + vec3( 0, speed * -time, 0 ), vec3( 100.0 ) ) * noise_amplitude;

              vec3 newPosition = vec3(position.x,position.y,displacement + (sin(position.x *.5 - H_PI )) * sine_amplitude + (main_wave_amplitude * sin(((time * 0.5 * speed) - (sqrt(((uv.x-0.5) * (uv.x-0.5)) + ((uv.y-0.5) * (uv.y-0.5))) * main_wave_frequency)) * M_PI)) );
              gl_Position      = projectionMatrix * modelViewMatrix * vec4( newPosition, 1. );
          
          }

    `;


    let gridFragmentSource = `

          uniform vec3  line_color;
          uniform float alphaValue;
          uniform vec3 rgbTarget;
          
          varying vec2 v_uv;
          varying float z;

          #define M_PI 3.1415926535897932384626433832795

          void main() {
            
            //vec3 image = texture2D( mapTile, v_uv ).xyz;
            gl_FragColor = vec4( rgbTarget, alphaValue );

          }

    `;

    this.gridMat = new THREE.ShaderMaterial({
              uniforms:{
                  time: {type: "f", value: 0},
                  speed: {type: "f", value: .5},
                  rgbTarget: { type: "c", value:new THREE.Color("rgb(255,255,255)") },
                  //rgbTarget: { type: "c", value:new THREE.Color("rgb(" + rgb.r + "," + rgb.g + "," +  rgb.b + ")") },

                  sine_amplitude: {type: "f", value: .12 },

                  noise_amplitude: {type: "f", value: .38 },

                  main_wave_amplitude: {type: "f", value: .25},
                  main_wave_frequency: {type: "f", value: 2.81 },
                  alphaValue: {type: "f", value: 0.0 },

                  line_color: {type: "c", value: new THREE.Color( 0x000000 )},
              },
              vertexShader: gridVertexSource,
              fragmentShader: gridFragmentSource,
              opacity:0.0,
              transparent: true,
              side:THREE.DoubleSide,
              flatShading: true


    });


    let gridGeom = new THREE.PlaneBufferGeometry( 10, 10, 7, 7 );
    let gridMesh = new THREE.Mesh( gridGeom, this.gridMat );

    this.gridBase.add( gridMesh );


    gridMesh.scale.x = 4;
    gridMesh.scale.y = 2;
    gridMesh.position.x = -3;
    gridMesh.visible = false;




    this.video = document.createElement('video');
    this.video.src = "./video/TheOverlay_trailer.mp4";
    this.video.setAttribute('preload', 'auto');
    this.video.setAttribute('muted', '');
    this.video.setAttribute('playsinline', '');
    this.video.setAttribute('webkit-playsinline', '');

    this.video.onended = function(e) {
        _self.video.pause();
        _self.video.currentTime = 0;
        _self.video.play();
    };
    this.texturev = new THREE.VideoTexture(this.video);
    this.texturev.minFilter = THREE.LinearFilter;
    this.texturev.magFilter = THREE.LinearFilter;
    this.texturev.format = THREE.RGBFormat;
    this.texturev.anisotropy = 16;
    this.texturev.crossOrigin = 'anonymous';

    this.moviePlane.scale.x = -1;
   /* this.videoObj = new THREE.Mesh(
        new THREE.PlaneGeometry(10, 10),
        new THREE.MeshBasicMaterial({ map:texturev, side:THREE.FrontSide } )
    );

    this.videoObj.position.z = -1.2;
    this.videoObj.scale.set( 0.25, 0.15, 0.25 );
    this.videoObj.visible = false;  
*/
    
    this.video.load();


    //this.camera.add( this.videoObj );


    return ground;


  }



  componentDidMount() {

    this.isRunning   = false;
    this.coockies    = false;
    this.loadCount   = 0;
    this.envMap      = null;
    this.moviePlays  = false;
    this.gridMat     = null;
    this.gridBase    = null;
    this.video       = null;
    this.videoObj    = null;
    this.texturev    = null;
    this.equiMap     = null;
    this.ground      = null;
    this.groundObj   = null;
    this.model_bambi = null;
    this.model_deer  = null;
    this.moviePlane  = null;
    this.raycaster   = null;
    this.grass       = null;
    this.areaWidth   = 240;  
    this.dust        = null;
    this.markerIsSet = false;
    this.mouse       = null;
    this.mouseTarget = null;
    this.windowHalf  = null;    
    this.topic       = 1;
    this.simpleGrainPass = null;
    this.devMobile     = navigator.userAgent.toLowerCase().match(/mobile/i);

    var self       = this;
    window["topic"] = 1;

    var loader = new THREE.CubeTextureLoader();
    loader.setPath( './' );
    loader.load(
 
        // urls of images used in the cube texture
        this.state.textureArray[this.loadCount][0],
     
        // what to do when loading is over
        function (cubeTexture) {
            
            self.loadCount = 1;
            self.envMap    = cubeTexture;

            //self.loadTextures();
            self.loadModel();
     
        }
 
    );

  }


  resize() {
    
    this.container = this.refs.container;

    this.width     = this.container.offsetWidth;
    this.height    = this.container.offsetHeight;

    this.renderer.setSize( this.width, this.height );
    
    if( this.composer ) {

        this.composer.setSize( this.width, this.height );

        var pixelRatio = this.renderer.getPixelRatio();
        
        //this.fxaaPass.material.uniforms[ 'resolution' ].value.x = 1 / ( this.width  * pixelRatio );
        //this.fxaaPass.material.uniforms[ 'resolution' ].value.y = 1 / ( this.height * pixelRatio );

        this.tiltShiftPass.material.uniforms[ 'resolution' ].value.x = this.width * pixelRatio;
        this.tiltShiftPass.material.uniforms[ 'resolution' ].value.y = this.height * pixelRatio;        
    }

    this.camera.aspect = this.width / this.height;  
    this.camera.updateProjectionMatrix();

  }

  renderFrame() {

    //this.stats.begin();

    this.thisFrame = Date.now();
    this.time += ( this.thisFrame - this.lastFrame) / 2500; 
    this.lastFrame = this.thisFrame;

    let now = performance.now();


    if( this.isRunning && !this.moviePlays ) {

        this.mouseTarget.x = ( 1 - this.mouse.x ) * 0.003;
        this.mouseTarget.y = ( 1 - this.mouse.y ) * 0.003;
        this.groundObj.rotation.y -= 0.0001 * ( this.mouseTarget.x + this.groundObj.rotation.y );

        if( !this.markerIsSet ) {

            if( this.topic === 1 ) {
                
                if( this.groundObj.rotation.y < -0.2 ) this.groundObj.rotation.y = -0.2;
                if( this.groundObj.rotation.y >  0.2 ) this.groundObj.rotation.y =  0.2;

            }

            if( this.topic === 2 ) {
                
                if( this.groundObj.rotation.y < -1.32 ) this.groundObj.rotation.y = -1.32;
                if( this.groundObj.rotation.y >  -1.2 ) this.groundObj.rotation.y =-1.2;
                
                this.moviePlane.userData.uniforms.iTime.value = now * 0.0005;
                
            }
        }
    }

    ////////////////////////////////////////////////////////////////////
    // update: dust          ///////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////

    this.dust.renderDust( now, this.camera );



    ////////////////////////////////////////////////////////////////////
    // update: postpro grain ///////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////

    this.simpleGrainPass.uniforms.time.value = this.time;



    ////////////////////////////////////////////////////////////////////
    // update: resize        ///////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////

    if( this.width !== this.container.offsetWidth || this.height !== this.container.offsetHeight ) {

        this.resize();

    }



    ////////////////////////////////////////////////////////////////////
    // update: rendering     ///////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////

    if( this.composer ) {

        this.renderer.setRenderTarget( this.depthRenderTarget  );
        this.renderer.render( this.scene, this.camera );
        this.composer.render();

    } else {

//        this.renderer.clear();
//        this.renderer.render( this.scene, this.camera ); 

    }  
  

    //this.stats.end();

    this.frameRequest = requestAnimationFrame( () => {

      this.renderFrame();

    });

  }

  componentWillUnmount() {

    cancelAnimationFrame(this.frameRequest);

  }

  render() {
    return (
      <div className="tinkerNode" ref="container"></div>
    );
  }
}

export default TinkerGrounds;
